{
  "action": {
    "accept": "Accetto",
    "acceptRedundancy": "Conferma ridondante",
    "activate": "Attiva",
    "add": "Aggiungi",
    "addExistingDocument": "Aggiungi documento esistente",
    "addField": "Aggiungi campo",
    "addFieldMapping": "Aggiungi mappatura",
    "addHint": "Premi invio per aggiungere",
    "addIntegration": "Aggiungi integrazione",
    "addMember": "Aggiungi membro",
    "addNestedField": "Campo annidato",
    "addToCalendar": "Aggiungi al calendario",
    "allDocuments": "Tutti i documenti",
    "analyzeChat": "Analizza conversazione",
    "apply": "Applica",
    "ask": "Chiedi",
    "attachFile": "Allega un file",
    "back": "Indietro",
    "backToAgent": "Torna all'agente",
    "backToDocuments": "Torna ai documenti",
    "backToHome": "Torna alla Home",
    "backToSignIn": "Torna al login",
    "ban": "Banna utente",
    "blockChat": "Blocca conversazione",
    "cancel": "Annulla",
    "cancelInvitation": "Annulla invito",
    "change": "Modifica",
    "changeAgent": "Cambia agente",
    "changeRole": "Cambia ruolo",
    "check": "Verifica",
    "clear": "Pulisci",
    "clearSearch": "Cancella ricerca",
    "close": "Chiudi",
    "closeSidebar": "Chiudi la sidebar",
    "collapse": "Collassa",
    "compare": "Confronta",
    "connect": "Collega",
    "continue": "Continua",
    "copied": "Copiato",
    "copy": "Copia",
    "crawl": "Esegui Crawling",
    "create": "Crea",
    "createAgent": "Crea agente",
    "createApiKey": "Crea API Key",
    "createDocument": "Crea documento",
    "createFolder": "Crea cartella",
    "createNew": "Crea nuovo",
    "createNewChat": "Inizia una nuova chat",
    "createNotification": "Crea notifica",
    "createRevise": "Correggi la risposta",
    "createSubfolder": "Crea sottocartella",
    "deactivate": "Disattiva",
    "decline": "Rifiuto",
    "delete": "Elimina",
    "deleteAllMemories": "Elimina tutte le memorie",
    "deleteAllNotifications": "Elimina tutte le notifiche",
    "deleteFolder": "Elimina cartella",
    "deleteMyConversations": "Cancella le mie conversazioni",
    "deleteProfile": "Elimina profilo",
    "deleteRow": "Elimina riga",
    "deselectHint": "Premi invio per rimuovere",
    "disableAutoRefresh": "Disabilita aggiornamento automatico",
    "disconnect": "Disconnetti",
    "dismissRedundancy": "Ripristina nella ricerca",
    "download": "Scarica",
    "downloadIcs": "Scarica .ics",
    "downloadTeamsApp": "Scarica app Teams (.zip)",
    "downvote": "Non mi piace",
    "dropFile": "Trascina il file qui",
    "dropFilesToImport": "Rilascia i file per importare i documenti",
    "duplicate": "Duplica",
    "edit": "Modifica",
    "editAgent": "Modifica agente",
    "editDocument": "Modifica documento",
    "editRevise": "Modifica la risposta",
    "editSchema": "Modifica schema",
    "enableAutoRefresh": "Abilita aggiornamento automatico",
    "expand": "Espandi",
    "export": "Esporta",
    "exportMyData": "Esporta i miei dati",
    "feedback": "Voglio fare una segnalazione",
    "foldSidebar": "Chiudi barra laterale",
    "forgetPassword": "Hai dimenticato la password?",
    "generate": "Genera",
    "generateFromJson": "Genera da JSON",
    "getDirections": "Indicazioni",
    "getMoreInfo": "Maggiori informazioni",
    "goBack": "Indietro",
    "hangUp": "Chiudi la chiamata",
    "impersonate": "Impersonifica",
    "import": "Importa ({count})",
    "importFromCrawler": "Importa da Crawler",
    "invite": "Invita",
    "inviteMember": "Invita membro",
    "leave": "Abbandona",
    "link": "Collega",
    "linkExisting": "Collega esistente",
    "loadDefaults": "Carica default",
    "manageAgentAccess": "Gestisci accesso agenti",
    "manageProfile": "Gestisci il tuo profilo",
    "markAllAsRead": "Segna tutto come letto",
    "markAsRead": "Segna come letto",
    "moreActions": "Azioni",
    "moveDown": "Sposta giù",
    "moveHere": "Sposta qui",
    "moveToFolder": "Sposta nella cartella",
    "moveUp": "Sposta su",
    "mute": "Disattiva il microfono",
    "next": "Avanti",
    "open": "Apri",
    "openFilters": "Apri i filtri",
    "openInGmail": "Apri in Gmail",
    "openInMailApp": "Apri con l'app di posta",
    "openInOutlook": "Apri in Outlook",
    "openInSms": "Apri in SMS",
    "openInTelegram": "Apri in Telegram",
    "openInWhatsApp": "Apri in WhatsApp",
    "openInYahooMail": "Apri in Yahoo Mail",
    "openSettings": "Apri le impostazioni",
    "openSidebar": "Apri la sidebar",
    "pan": "Sposta",
    "pin": "Blocca",
    "playVoicePreview": "Ascolta un esempio di questa voce",
    "prev": "Indietro",
    "previewAsPage": "Anteprima come pagina chat",
    "previewAsWidget": "Anteprima come widget",
    "previous": "Indietro",
    "proceed": "Procedi",
    "profileMenu": "Profilo, tema e lingua",
    "recoverPassword": "Recupera password",
    "refill": "Ricarica",
    "refillHistory": "Storico ricariche",
    "refresh": "Aggiorna",
    "regenerate": "Rigenera",
    "remove": "Rimuovi",
    "removeField": "Rimuovi campo",
    "renameChat": "Rinomina",
    "renameFolder": "Rinomina cartella",
    "reorder": "Riordina",
    "reprocess": "Riprocessa",
    "resendInvitation": "Invia nuovamente l'invito",
    "reset": "Reset",
    "resetPassword": "Reimposta password",
    "resize": "Ridimensiona",
    "resumeInPlayground": "Riprendi nel playground",
    "retry": "Riprova",
    "retryNow": "Riprova ora",
    "revoke": "Revoca",
    "revokeAllOtherSessions": "Disconnetti tutte",
    "revokeAllSessions": "Revoca tutte le sessioni",
    "rootDocuments": "Senza cartella",
    "run": "Esegui",
    "save": "Salva",
    "scrollToBottom": "Torna in fondo",
    "searchAllFolders": "Cerca in tutte le cartelle",
    "select": "Seleziona",
    "selectHint": "Premi invio per selezionare",
    "selected": "Selezionati",
    "send": "Invia",
    "share": "Condividi",
    "shareDocumentWithAgents": "Condividi con altri agenti",
    "showLess": "Mostra di meno",
    "showMore": "Visualizza altre {count}",
    "signIn": "Accedi",
    "signInWithSocialProvider": "Accedi con {provider}",
    "signOut": "Esci",
    "signUp": "Registrati",
    "signUpWithSocialProvider": "Registrati con {provider}",
    "startNewChat": "Inizia una nuova chat",
    "stop": "Ferma",
    "stopImpersonation": "Torna al tuo profilo",
    "stopVoicePreview": "Ferma l'esempio",
    "submit": "Invia",
    "switch": "Cambia",
    "takePhoto": "Scatta una foto",
    "talk": "Parla",
    "testIntegration": "Verifica connessione",
    "toggleIntegration": "Abilita/Disabilita",
    "toggleTheme": "Cambia tema",
    "unban": "Sblocca utente",
    "unblockChat": "Sblocca conversazione",
    "unfoldSidebar": "Apri barra laterale",
    "unlinkDocument": "Rimuovi dall'agente",
    "unmute": "Riattiva il microfono",
    "unpin": "Sblocca",
    "update": "Aggiorna",
    "upvote": "Mi piace!",
    "useColorsForAgentHeader": "Colora l'intestazione",
    "view": "Visualizza",
    "viewAgentTree": "Dipendenze",
    "viewAll": "Vedi tutte",
    "viewChat": "Visualizza la chat",
    "viewDetails": "Visualizza dettagli",
    "viewProfile": "Visualizza profilo",
    "viewRecentChats": "Visualizza chat recenti",
    "welcomePopup": "Mostra popup di benvenuto",
    "writeMessage": "Scrivi un messaggio",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci"
  },
  "agent": {
    "channel": {
      "app": "App",
      "frontoffice": "Frontoffice",
      "widget": "Widget"
    },
    "reasoning": {
      "high": "Alto",
      "low": "Basso",
      "medium": "Medio",
      "off": "Disattivo"
    },
    "reasoningSummary": {
      "auto": "Auto",
      "concise": "Conciso",
      "detailed": "Dettagliato"
    },
    "searchMode": {
      "balanced": "Bilanciato (vettoriale + parole chiave)",
      "keyword": "Parole chiave (solo full-text)",
      "semantic": "Semantico (solo vettoriale)"
    },
    "status": {
      "active": "Attivo",
      "draft": "Bozza",
      "inactive": "Inattivo"
    },
    "tool": {
      "fetchTeamsChannelHistory": "Cronologia canale Teams",
      "geocode": "Geocodifica",
      "getWeather": "Dati meteo",
      "readDocumentFile": "Lettura file documenti",
      "requestGeolocation": "Geolocalizzazione",
      "retrieveRevisedAnswers": "Risposte verificate",
      "runWorker": "Worker parallelo",
      "searchInKnowledgeBase": "Knowledge base",
      "searchInUserFiles": "File dell'utente",
      "showArtifact": "Artefatti",
      "showCalendarEvent": "Evento calendario",
      "showComparison": "Confronto",
      "showContactForm": "Modulo di contatto",
      "showDiagram": "Diagramma o grafico",
      "showEmail": "Email",
      "showForm": "Modulo multi-step",
      "showImageGallery": "Galleria immagini",
      "showLocation": "Mappa interattiva",
      "showMessage": "Messaggistica",
      "showMultipleChoice": "Scelta multipla",
      "showProductList": "Catalogo prodotti",
      "showQrCode": "Codice QR",
      "showSources": "Fonti e riferimenti",
      "showSuggestedReply": "Risposte suggerite",
      "showVideo": "Video",
      "showWeather": "Widget meteo",
      "showWebPages": "Link a pagine web",
      "useAllUserFiles": "Utilizza tutti i file utente",
      "useAllUserKb": "Utilizza tutta la KB utente",
      "userMemory": "Memoria utente"
    },
    "visibility": {
      "organization": "Organizzazione",
      "private": "Privato",
      "public": "Pubblico"
    }
  },
  "agentApiToolStatus": {
    "active": "Attivo",
    "inactive": "Inattivo"
  },
  "agentType": {
    "chat": "Chat",
    "reasoning": "Ragionamento"
  },
  "auth": {
    "emailInUse": "Esiste già un account con questa email",
    "emailNotVerified": "Verifica il tuo indirizzo email",
    "genericError": "Si è verificato un errore. Riprova.",
    "haveAccount": "Hai già un account?",
    "invalidCredentials": "Email o password non validi",
    "noAccount": "Non hai un account?",
    "popupBlocked": "Finestra popup bloccata. Consenti i popup per questo sito e riprova.",
    "resetSent": "Se esiste un account con questa email, riceverai un link per reimpostare la password.",
    "resetSentTitle": "Controlla la tua email",
    "resetTitle": "Reimposta la tua password",
    "signInTitle": "Accedi al tuo account",
    "signUpSuccessTitle": "Account creato!",
    "signUpTitle": "Crea il tuo account",
    "verifyEmail": "Abbiamo inviato un'email di verifica al tuo indirizzo. Controlla la tua casella di posta."
  },
  "browserEngine": {
    "fetch": "Fetch · HTML statico",
    "puppeteer": "Puppeteer · browser locale",
    "remote": "Remote · browser remoto"
  },
  "channelDescription": {
    "teams": "Pubblica questo agente come bot all'interno di Microsoft Teams.",
    "whatsapp": "Permetti agli utenti di scrivere a questo agente su WhatsApp tramite le API Meta Cloud."
  },
  "channelGuide": {
    "docs": "Apri la documentazione ufficiale",
    "intro": "Segui i passaggi nell'ordine. Apri ogni servizio collegato in una nuova scheda del browser e copia i valori nel form a sinistra. Non chiudere questa finestra finché non hai finito.",
    "teams": {
      "step1": "Accedi al portale Microsoft Azure con il tuo account aziendale o scolastico.",
      "step2": "Crea una nuova risorsa «Azure Bot» e dalle un nome. Quando richiesto, scegli se è Single o Multi-tenant — ricorda la scelta per il passaggio 5.",
      "step3": "Apri il bot appena creato → «Configuration», copia il «Microsoft App ID» e incollalo nel campo App ID.",
      "step4": "Accanto al Microsoft App ID clicca «Manage password»: si apre la registrazione dell'app in Microsoft Entra ID (una pagina diversa dal bot). Lì, sotto «Certificates & secrets», crea un nuovo client secret e copia il suo «Value» (non il Secret ID) nel campo App password. Copialo subito — viene mostrato una sola volta.",
      "step5": "Imposta l'App type uguale a quanto scelto al passaggio 2. Per Single tenant, copia il «Directory (tenant) ID» dalla pagina «Overview» della registrazione dell'app nel campo Tenant ID.",
      "step6": "Torna nel bot → «Configuration», imposta il «Messaging endpoint» sul Webhook URL mostrato sopra e salva.",
      "step7": "Apri il bot → «Channels» e aggiungi il canale «Microsoft Teams».",
      "step8": "Salva il form a sinistra, poi usa il menu della card (⋯ → Scarica app Teams) per ottenere il pacchetto e caricalo in Teams da «App → Gestisci le tue app → Carica un'app»."
    },
    "title": "Guida alla configurazione",
    "whatsapp": {
      "step1": "Apri il portale Meta for Developers e accedi con il tuo account Facebook (creane uno se non ce l'hai).",
      "step2": "Crea una nuova app: scegli il tipo «Business», dai un nome, poi aggiungi il prodotto «WhatsApp».",
      "step3": "Apri WhatsApp → «API Setup». Copia il «Phone number ID» (un numero lungo, non il numero di telefono) e incollalo nel campo Phone number ID.",
      "step4": "Sempre in «API Setup», genera un access token. Per una connessione che non scade, crea un token «System User» con il permesso whatsapp_business_messaging e incollalo nel campo Access token.",
      "step5": "Apri Impostazioni app → «Base», clicca «Mostra» accanto a «Chiave segreta dell'app», copiala e incollala nel campo App secret. Serve a verificare che i messaggi in arrivo provengano davvero da Meta.",
      "step6": "Abbiamo già compilato il campo «Verify token» con un valore pronto all'uso (usa «Rigenera» per crearne uno nuovo). Incollerai esattamente questo valore in Meta al passaggio successivo.",
      "step7": "Torna su WhatsApp → «Configuration» e modifica il webhook: incolla il Webhook URL mostrato sopra e lo stesso Verify token, salva, poi iscriviti all'evento «messages».",
      "step8": "Salva il form a sinistra. Invia un messaggio al tuo numero WhatsApp per verificare che l'agente risponda."
    }
  },
  "chartLabel": {
    "2g": "2G",
    "3g": "3G",
    "4g": "4G",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Australia": "Australia",
    "Europe": "Europa",
    "Pacific": "Pacifico",
    "abusive": "Offensivo",
    "aggressive": "Aggressivo",
    "api": "API",
    "critical": "Critico",
    "dark": "Scuro",
    "data_leak": "Fuga di dati",
    "degrading": "In peggioramento",
    "desktop": "Desktop",
    "direct": "Diretto",
    "disengaged": "Disinteressato",
    "endpoint": "Endpoint",
    "excited": "Entusiasta",
    "false_success": "Falso successo",
    "frustrated": "Frustrato",
    "goal_met": "Obiettivo raggiunto",
    "goal_not_met": "Obiettivo non raggiunto",
    "group": "Gruppo",
    "hallucination": "Allucinazione",
    "high": "Alto",
    "impatient": "Impaziente",
    "improving": "In miglioramento",
    "inappropriate_tone": "Tono inappropriato",
    "light": "Chiaro",
    "low": "Basso",
    "medium": "Medio",
    "mobile": "Mobile",
    "negative": "Negativo",
    "neutral": "Neutro",
    "off_brand": "Fuori tono",
    "other": "Altro",
    "polite": "Cortese",
    "positive": "Positivo",
    "reasoning": "Reasoning",
    "refusal_loop": "Loop di rifiuto",
    "repetition": "Ripetizione",
    "slow-2g": "2G lento",
    "stable": "Stabile",
    "tablet": "Tablet",
    "teams": "Teams",
    "unanalyzed": "Non analizzato",
    "unclear": "Non chiaro",
    "unknown": "Sconosciuto",
    "voice": "Voce",
    "web": "Web",
    "whatsapp": "WhatsApp"
  },
  "conversationAnalysis": {
    "abuseCategory": {
      "data_extraction": "Estrazione dati",
      "harassment": "Molestia",
      "hate_speech": "Incitamento all'odio",
      "impersonation": "Impersonificazione",
      "off_topic_persistent": "Fuori tema",
      "prompt_injection": "Prompt injection",
      "self_harm": "Autolesionismo",
      "sexual_content": "Contenuto sessuale",
      "spam": "Spam",
      "violence": "Violenza"
    },
    "confidence": {
      "high": "Alta",
      "low": "Bassa",
      "medium": "Media"
    },
    "engagement": {
      "disengaged": "Disimpegnato",
      "high": "Alto",
      "low": "Basso",
      "medium": "Medio"
    },
    "label": {
      "abuseDetected": "Abuso",
      "conversationSentiment": "Sentiment",
      "goalMet": "Obiettivo raggiunto",
      "goalNotMet": "Obiettivo non raggiunto",
      "llmIssueDetected": "Problema LLM",
      "riskScore": "Punteggio di rischio",
      "userEngagement": "Coinvolgimento",
      "userTone": "Tono"
    },
    "llmIssue": {
      "data_leak": "Fuga di dati",
      "false_success": "Falso successo",
      "hallucination": "Allucinazione",
      "inappropriate_tone": "Tono inappropriato",
      "off_brand": "Fuori brand",
      "refusal_loop": "Loop di rifiuto",
      "repetition": "Ripetizione"
    },
    "sentiment": {
      "excited": "Entusiasta",
      "frustrated": "Frustrato",
      "negative": "Negativo",
      "neutral": "Neutro",
      "positive": "Positivo"
    },
    "sentimentTrend": {
      "degrading": "In peggioramento",
      "improving": "In miglioramento",
      "stable": "Stabile"
    },
    "title": "Analisi conversazione",
    "tone": {
      "abusive": "Offensivo",
      "aggressive": "Aggressivo",
      "impatient": "Impaziente",
      "neutral": "Neutro",
      "polite": "Cortese"
    },
    "trigger": {
      "agent_request": "Su richiesta",
      "manual": "Manuale",
      "summary_cycle": "Automatico"
    }
  },
  "crawlMode": {
    "depth": "Pagina iniziale",
    "sitemap": "Sitemap XML"
  },
  "diagram": {
    "classDiagram": "Diagramma di Classe",
    "erDiagram": "Diagramma ER",
    "flowchart": "Diagramma di Flusso",
    "graph": "Grafico",
    "sequenceDiagram": "Diagramma di Sequenza",
    "stateDiagram": "Diagramma di Stato",
    "xychart": "Grafico XY"
  },
  "documentMetadata": {
    "affectedDocumentsStat": "Documenti coinvolti",
    "analyzedPages": "analizzate {pages} su",
    "availableForSearch": "Disponibile per la ricerca dell'agente",
    "chunkSimilarTo": "Simile al {score}% a un contenuto in «{docName}»",
    "compare": "Confronta",
    "compareChunks": "Confronto Semantico Chunk",
    "filterOnlyRedundantLabel": "Mostra solo documenti con chunk ridondanti non gestiti",
    "filterRedundant": "Mostra ridondanti",
    "hasRedundant": "Questo documento contiene informazioni ridondanti con altri file",
    "isRedundant": "Ridondante",
    "notAvailableForSearch": "Non disponibile per la ricerca dell'agente",
    "originalChunk": "Chunk Originale (Autorevole)",
    "pageCount": "nessuna pagina | {n} pagina | {n} pagine",
    "readingTime": "{minutes} min",
    "redundancyAccepted": "Confermato",
    "redundancyDismissed": "Ripristinato",
    "redundancyExplainer": "Questi blocchi di testo sono molto simili a contenuti già presenti in altri documenti. Conferma la ridondanza per escluderli dalla ricerca, oppure ripristinali per mantenerli attivi.",
    "redundantChunk": "Chunk Ridondante (Duplicato)",
    "redundantChunks": "nessun chunk ridondante | {n} chunk ridondante ({percent}%) | {n} chunk ridondanti ({percent}%)",
    "redundantChunksStat": "Chunk ridondanti",
    "redundantWarningMessage": "Alcuni documenti contengono chunk ridondanti. Saranno esclusi automaticamente per ottimizzare il contesto del chatbot di recupero RAG.",
    "redundantWarningServerMessage": "Ci sono {chunks} chunk ridondanti non gestiti distribuiti in {docs} documenti di questo agente (su un totale di {totalChunks} chunk e {totalDocs} documenti).",
    "redundantWarningTitle": "Rilevati contenuti duplicati o ridondanti nella Knowledge Base",
    "redundantWith": "Ridondante con il chunk {chunkId} di {docName} ({score}% similarità semantica)",
    "searchNotSynced": "In preparazione",
    "searchSynced": "Disponibile",
    "showAll": "Mostra tutti",
    "thisDocument": "Questo documento",
    "viewByChunks": "Visualizza a chunk",
    "viewDocument": "Documento",
    "viewOriginal": "Vedi originale",
    "wordCount": "{count} parole"
  },
  "documentStatus": {
    "failed": "Fallito",
    "pending": "In attesa",
    "processing": "In elaborazione",
    "success": "Completato"
  },
  "documentType": {
    "file": "File",
    "plain-text": "Testo",
    "revised-answer": "Risposta",
    "url": "Pagina web"
  },
  "errors": {
    "RATE_LIMIT_EXCEEDED": "Limite di richieste superato",
    "fileAlreadyImported": "Questo file è già stato importato come documento",
    "invalidToken": "Richiesta non più valida",
    "passwordsDoNotMatch": "Le password non coincidono",
    "required": "Obbligatorio",
    "slugAlreadyExists": "Lo slug esiste già",
    "slugFormat": "Lo slug può contenere solo lettere minuscole, numeri e trattini (-)",
    "urlAlreadyImported": "Questo URL è già stato importato come documento"
  },
  "externalProvider": {
    "domain": "Dominio email",
    "github": "GitHub",
    "google": "Google",
    "microsoft": "Microsoft Entra"
  },
  "gdprRetention": {
    "anonymousLabel": "Cancellazione utenti anonimi",
    "chatLabel": "Anonimizzazione chat",
    "defaultDays": "Predefinito: {count} giorno. | Predefinito: {count} giorni.",
    "defaultDisabled": "Predefinito: disattivato.",
    "legend": "Conservazione dei dati (GDPR)",
    "unitDays": "giorni"
  },
  "help": {
    "aiDescription": "Un modello AI analizza il file e genera una descrizione strutturale del contenuto. Utile per documenti con tabelle, grafici o layout complessi.",
    "aiDescriptionModel": "Il modello AI usato per generare la descrizione",
    "aiDescriptionPrompt": "Prompt utilizzato per generare la descrizione",
    "browserEngine": "Come viene caricata la pagina prima dell'estrazione",
    "documentFile": "Sono consentiti PDF, Word (.docx), file di testo (.txt, .md, .csv) e immagini (.png, .jpg, .webp, .gif)",
    "fetchBrowserEngine": "veloce, recupera l'HTML statico. Ideale per la maggior parte dei siti.",
    "followExternal": "Recupera link da domini diversi",
    "forceOcr": "Forza l'estrazione testo tramite OCR (Document Intelligence). Utile per PDF scansionati o quando l'estrazione normale produce risultati insufficienti.",
    "pages": "Specifica quali pagine processare. Lascia vuoto per processare tutte le pagine. L'estrazione avverrà tramite OCR (Document Intelligence).",
    "puppeteerBrowserEngine": "esegue JavaScript con un browser locale. Per pagine dinamiche o single-page.",
    "remoteBrowserEngine": "come Puppeteer, ma su un browser remoto. Aggira blocchi e rilevamento bot.",
    "useBrowserEngine": "Più lento, ma consente l'analisi di pagine dinamiche",
    "useExtractionStrategy": "Migliora l'estrazione dei dati con l'AI"
  },
  "hint": {
    "allowedDomains": "Cerca solo all'interno di questi domini.",
    "approvalChannels": "Un tool può chiedere conferma all'utente prima di eseguire: espandi il tool per attivarla. Via API o in esecuzioni schedulate la chiamata viene rifiutata.",
    "audience": "L'audience attesa del token JWT (aud). Se vuota, l'audience non viene verificata.",
    "blockedDomains": "Escludi questi domini dai risultati.",
    "channel": {
      "app": "L'agente è accessibile tramite la pagina pubblica dedicata.",
      "frontoffice": "L'agente è visibile nel pannello Frontoffice.",
      "widget": "L'agente è incorporabile nei siti web tramite embed script."
    },
    "channelAppDisabled": "Il canale App è disabilitato: il link diretto e l'iframe non funzioneranno.",
    "channelWidgetDisabled": "Il canale Widget è disabilitato: il codice embed e il loader non funzioneranno.",
    "customCss": "CSS iniettato nello shadow DOM del widget. Permette di personalizzare l'interfaccia della chat dall'esterno.",
    "disallowPromptTraining": "Instrada le richieste solo verso provider che non usano i dati per addestrare i modelli AI.",
    "dismissableNotice": "Verrà nascosto dopo il primo messaggio.",
    "emailClaim": "Il claim JWT che contiene l'email dell'utente (default: email).",
    "embedCode": "Copia e incolla questo codice per incorporare l'agente nel tuo sito web.",
    "embedIframe": "Incorpora l'interfaccia della chat direttamente con un iframe.",
    "embedPreview": "L'agente sarà accessibile al seguente URL.",
    "externalContextSchema": "Definisci quali dati contestuali il sito ospitante può inviare all'agente.",
    "externalContextSchemaToggle": "Abilita la ricezione di dati contestuali dal sito ospitante.",
    "fallbackModels": "Modelli alternativi tentati in ordine se il modello primario non è disponibile.",
    "fieldMappingFallback": "Valore usato se il campo sorgente è vuoto o assente.",
    "fieldMappingSource": "Supporta percorsi annidati (es. metadata.urgency).",
    "fieldMappingTransformExtractDomainCompany": "Estrae il nome azienda dal dominio email (es. mario@acme.it → Acme). Ignora i provider gratuiti (gmail, outlook, ecc.).",
    "fieldMappingTransformJoinArray": "Unisce i valori di un array separandoli con virgola.",
    "fieldMappingTransformMapValues": "Sostituisce il valore usando la tabella di mappatura.",
    "fieldMappingTransformNone": "Copia il valore così com'è.",
    "fieldMappingTransformSplitFirstLast": "Divide il testo sugli spazi.",
    "fileUploadDisabledHint": "Il caricamento file non è abilitato per questo agente. Puoi abilitarlo nelle impostazioni dell'agente.",
    "fileUploadEnabled": "Permetti agli utenti di allegare file ai messaggi.",
    "freshnessBoost": "Applica un boost basandosi su quanto recentemente il documento è stato aggiornato.",
    "freshnessScale": "Scala temporale spinta (Giorni)",
    "freshnessScaleExplanation": "Il bonus si dimezza dopo {half} giorni e si azzera praticamente dopo {zero} giorni ({zero} mesi).",
    "freshnessScaleExplanationDays": "Un documento modificato oggi ottiene un bonus di +{weight}. Il bonus si dimezza a +{halfWeight} dopo {half} giorni e si azzera praticamente (+{zeroWeight}) dopo {zero} giorni.",
    "freshnessScaleExplanationMonths": "Un documento modificato oggi ottiene un bonus di +{weight}. Il bonus si dimezza a +{halfWeight} dopo {half} giorni e si azzera praticamente (+{zeroWeight}) dopo {zero} giorni (circa {months} mesi).",
    "freshnessScaleExplanationYears": "Il bonus si dimezza dopo {half} giorni e si azzera praticamente dopo {zero} giorni ({years} anni).",
    "freshnessScaleTooltip": "Il tempo di dimezzamento (half-life) del decadimento esponenziale. Un documento vecchio esattamente quanto questo valore riceverà il 50% del boost massimo. Più è basso, più i documenti vecchi perderanno rapidamente il boost.",
    "freshnessWeight": "Moltiplicatore del peso del boost di freschezza nella formula.",
    "freshnessWeightTooltip": "Bonus massimo aggiunto allo score per i documenti appena modificati. Un peso di 0.1 significa che un documento freschissimo otterrà un vantaggio di +0.10 sullo score. Questo vantaggio decadrà esponenzialmente col tempo fino a azzerarsi.",
    "includeThoughts": "Invia i pensieri del modello al client insieme alla risposta.",
    "inputSchema": "JSON Schema (draft-07) dei parametri di input che l'LLM può fornire.",
    "interactiveLogin": "Permette agli utenti anonimi di accedere dalla chat. L'external token resta sempre attivo.",
    "issuer": "L'URL dell'issuer del token JWT (iss).",
    "jwksUrl": "L'URL dell'endpoint JWKS per la verifica della firma JWT.",
    "loadDelay": "Millisecondi di attesa prima di iniettare il widget. Utile su pagine con loader AMD lenti (es. RequireJS).",
    "loaderStrategy": {
      "dynamic-import": "Usa import() all'interno di un <script> classico. Fallback per pagine dove gli script module sono bloccati o intercettati da loader legacy.",
      "inline-module": "Inietta un <script type=\"module\"> inline con un import statico. Bypassa RequireJS e altri loader AMD. Consigliata per la maggior parte dei siti.",
      "script-src": "Carica il bundle tramite <script type=\"module\" src=\"...\">. Usala su siti con Content Security Policy (CSP) restrittiva che blocca gli script inline."
    },
    "mcpServerHealthCheckPath": "L'endpoint utilizzato per verificare lo stato del Server MCP (es: /api/health).",
    "mcpStatelessServer": "Forza il client a connettersi in modalità stateless.",
    "mmr": "Bilancia la rilevanza semantica e la diversità dei documenti nei risultati di ricerca per evitare contenuti ridondanti.",
    "mmrCandidatesLimit": "Numero massimo di chunk candidati pre-selezionati prima di applicare l'MMR.",
    "mmrCandidatesLimitTooltip": "Quanti risultati pre-selezionare dal database prima di filtrare e diversificare. Esempio: se impostato a 100, il sistema cercherà i 100 chunk più pertinenti e poi estrarrà tra questi quelli più diversi tra loro fino a raggiungere il limite finale per la chat.",
    "mmrDiversity": "Tradeoff tra rilevanza (0.0) e diversità (1.0).",
    "mmrDiversityTooltip": "Determina quanto spazio dare a informazioni diverse. Un valore vicino a 0 predilige i risultati più pertinenti anche se simili tra loro. Un valore vicino a 1 forza l'inserimento di risultati con dettagli e temi differenti, riducendo la ripetitività.",
    "multipleChoiceAllowCustomAnswer": "Mostra un campo di testo libero sotto le opzioni per consentire all'utente di inserire una risposta personalizzata.",
    "multipleChoiceMaxOptions": "Numero massimo di opzioni che l'AI può generare (min. 2, max. 10).",
    "nameClaim": "Il claim JWT che contiene il nome dell'utente (default: name). Se manca, il sistema prova name, given_name e family_name, e lo stesso namespace del claim email.",
    "oauthCallbackUrl": "Configura questa URL come Callback URL (Redirect URI) nel provider OAuth.",
    "outputSchema": "JSON Schema (draft-07) della risposta attesa. Solo documentativo.",
    "passphrase": "Inserisci {passphrase} per confermare l'operazione",
    "platformSupported": "Resa nativa su WhatsApp e Teams",
    "privacyPolicyNotice": "Visibile del modulo di contatto.",
    "providerOrganizationId": "Per Microsoft si riferisce all'identificativo del tenant (tenant ID). Per gli altri inserire il dominio dell'e-mail (es. company.com).",
    "providerTimeoutMs": "Timeout in millisecondi prima di passare al provider successivo (min 1000, max 789000). Solo credenziali BYOK.",
    "reasoningDefault": "Valore predefinito della piattaforma, si applica finché non scegli un valore diverso.",
    "reasoningNotSupported": "Il reasoning non è supportato per il provider selezionato.",
    "sessionExpiresIn": "Durata della sessione widget in secondi (min 60). Se vuoto vale il default di 8 ore.",
    "showExtendedSteps": "Visualizza la timeline con il ragionamento e gli strumenti nella chat.",
    "smoothStream": "Uniforma lo streaming del testo creando un'esperienza di lettura più naturale.",
    "subAgentName": "Sono consentiti solo lettere, numeri, underscore (_) e trattini (-).",
    "teamsAccentColor": "Per impostazione predefinita usa il colore del tema dell'agente.",
    "teamsAppVersion": "Incrementala (es. 1.0.1) e reinstalla il pacchetto per applicare le modifiche al manifest, come i nuovi permessi, alle app già installate.",
    "tool": {
      "fetchTeamsChannelHistory": "Sui canali Teams, permette all'agente di leggere su richiesta la conversazione più ampia del canale. Richiede la reinstallazione dell'app Teams.",
      "geocode": "Converte nomi di luoghi in coordinate geografiche e viceversa.",
      "getWeather": "Recupera i dati meteo attuali e le previsioni per una località specifica.",
      "readDocumentFile": "Permette all'agente di leggere il file originale dei documenti PDF/DOCX dalla knowledge base. Utile per tabelle, grafici e contenuti visivi.",
      "requestGeolocation": "Richiede la posizione GPS dell'utente tramite il browser.",
      "retrieveRevisedAnswers": "Recupera le risposte verificate dagli amministratori e le usa come fonte primaria.",
      "runWorker": "Permette all'agente di avviare worker generici che ereditano i suoi tool per gestire sotto-attività indipendenti in parallelo.",
      "searchInKnowledgeBase": "Cerca nei documenti caricati nella knowledge base per fornire risposte contestuali.",
      "searchInUserFiles": "Cerca nei file che l'utente ha caricato personalmente in chat (i suoi file privati), separati dalla knowledge base dell'agente.",
      "showArtifact": "Mostra contenuti strutturati come testi formattati, codice o documenti.",
      "showCalendarEvent": "Mostra un evento calendario con opzioni per Google Calendar, Outlook e download .ics.",
      "showComparison": "Confronta da 2 a 4 elementi affiancati per facilitare la scelta.",
      "showContactForm": "Mostra un modulo di contatto per raccogliere i dati dell'utente.",
      "showDiagram": "Mostra un grafico o un diagramma (flusso, sequenza, classe, ER, stato).",
      "showEmail": "Compone un'email pronta da inviare dal client di posta dell'utente.",
      "showForm": "Permette di raccogliere input strutturati (testo, numeri, date, scelte) tramite form multi-step.",
      "showImageGallery": "Raccoglie le immagini in una galleria navigabile con zoom e lightbox.",
      "showLocation": "Mostra una mappa interattiva con segnaposto e indicazioni stradali.",
      "showMessage": "Compone un messaggio da inviare tramite WhatsApp, Telegram o SMS.",
      "showMultipleChoice": "Propone opzioni selezionabili per guidare il flusso della conversazione.",
      "showProductList": "Mostra un elenco di prodotti con immagini, descrizioni e link d'acquisto.",
      "showQrCode": "Genera un codice QR a partire da testo, URL o dati strutturati.",
      "showSources": "Mostra i riferimenti ai documenti della knowledge base utilizzati nella risposta.",
      "showSuggestedReply": "Suggerisce risposte cliccabili per proseguire la conversazione.",
      "showVideo": "Riproduce video inline: file diretti (MP4/WebM) o link YouTube/Vimeo.",
      "showWeather": "Mostra un widget con le previsioni meteo direttamente nella chat.",
      "showWebPages": "Suggerisce link a pagine web pertinenti alla domanda dell'utente.",
      "useAllUserFiles": "Cerca in tutti i file dell'utente, anche quelli caricati su altri agenti, non solo in quelli di questo agente.",
      "useAllUserKb": "Legge le memorie che l'utente ha condiviso con tutti i suoi agenti, non solo con questo. La scrittura resta legata a questo agente.",
      "userMemory": "Permette all'agente di ricordare e richiamare informazioni che l'utente condivide tra le conversazioni (nome, preferenze, ecc.)."
    },
    "toolRequiresApproval": "Prima di eseguire, l'assistente attende l'approvazione in chat.",
    "useColorsForAgentHeader": "Colora l'intestazione dell'agente in base al colore principale.",
    "userFeedbackComment": "L'utente ha lasciato un commento su questa risposta",
    "userFeedbackNegative": "L'utente ha valutato negativamente questa risposta",
    "userFeedbackPositive": "L'utente ha valutato positivamente questa risposta",
    "userFeedbackReaction": "L'utente ha reagito a questa risposta",
    "voiceApprovalRefused": "Durante una chiamata queste azioni non partono: l'approvazione si dà a schermo e al telefono non c'è nessuno a cui chiederla, quindi l'agente le rifiuta e lo dice. Riguarda: {tools}.",
    "voiceCascadeTimeoutSeconds": "Quanto il fornitore aspetta noi prima di annullare il turno. Deve stare sopra al turno più lento dell'agente: knowledge base, tool e modelli lenti lo allungano.",
    "voiceEnabled": "Permette di parlare con questo agente. La risposta resta sua, con la sua knowledge base e i suoi strumenti.",
    "voiceFillerAfterSeconds": "Dice che sta lavorando quando la risposta tarda. Vuoto: quattro secondi.",
    "voiceFillerMessage": "Scrivila in modo che ogni continuazione suoni naturale. Vuoto: una frase predefinita nella lingua della voce.",
    "voiceFirstMessage": "Detta appena si apre la chiamata. Copre anche il primo turno, il più lento.",
    "voiceId": "Le voci clonate non sono in elenco: il fornitore non le ammette qui.",
    "voiceIgnoreBackgroundVoices": "Ascolta solo chi parla. Da tenere attivo dove il microfono sente la stanza.",
    "voiceLanguage": "Usata per riconoscere il parlato e per parlare.",
    "voiceMaxSessionSeconds": "Una chiamata si paga a minuto e si chiude da sola a questo limite.",
    "voiceRemaining": "Tempo che resta in questa chiamata",
    "voiceSlowAgentOnCall": "Una knowledge base grande o server MCP collegati possono far metterci diversi secondi all'agente, e in chiamata quei secondi sono silenzio: le due impostazioni qui sotto sono ciò che tiene compagnia a chi chiama mentre lavora. Se le chiamate sembrano lente, la risposta si accorcia anche con meno passi, un limite di retrieval più basso o un modello più rapido.",
    "voiceTurnEagerness": "Pronto risponde prima ma ti taglia sulle pause; paziente aspetta che tu finisca.",
    "voiceTurnTimeoutSeconds": "Quanto l’agente aspetta il chiamante zitto prima di riprendere la parola. Niente a che vedere con la sua velocità di risposta.",
    "webSearchEnabled": "Permetti all'agente di cercare informazioni sul web durante le conversazioni.",
    "webSearchNative": "Usa le funzionalità di ricerca web integrate di {provider}.",
    "webhookUrl": "Incolla questo URL nella configurazione del webhook / endpoint di messaggistica della piattaforma.",
    "welcomePopup": "Mostra un popup di benvenuto con il messaggio iniziale prima che la chat venga aperta.",
    "whatsappVerifyToken": "Incolla questo token nella configurazione webhook di Meta.",
    "zeroDataRetention": "Instrada le richieste solo verso provider con accordi ZDR. Restringe il pool di provider disponibili."
  },
  "integrationProvider": {
    "hubspot": "HubSpot",
    "salesforce": "Salesforce"
  },
  "integrationProviderDescription": {
    "hubspot": "Sincronizza i contatti con HubSpot CRM.",
    "salesforce": "Sincronizza i contatti con Salesforce CRM."
  },
  "integrationSyncStatus": {
    "failed": "Fallito",
    "pending": "In attesa",
    "success": "Successo"
  },
  "interval": {
    "D": "giorno | giorni",
    "M": "mese | mesi",
    "W": "settimana | settimane",
    "Y": "anno | anni"
  },
  "invitationStatus": {
    "accepted": "Accettato",
    "canceled": "Annullato",
    "expired": "Scaduto",
    "pending": "In attesa"
  },
  "label": {
    "AI": "AI",
    "acceptInvitationAndCreateAccount": "Accetta l'invito e crea il tuo account",
    "accountingCredit": "Saldo contabile",
    "active": "Attiva",
    "activeSessions": "Sessioni attive",
    "actualCost": "Costo reale",
    "addApiTool": "Aggiungi API Tool",
    "addIntegration": "Aggiungi integrazione",
    "additionalMetadata": "Metadati aggiuntivi",
    "admin": "Amministratore",
    "advancedOptions": "Opzioni avanzate",
    "agent": "Agente",
    "agentResponse": "Risposta agente",
    "agentTree": "Albero Agente",
    "agents": "Agenti",
    "agentsUsed": "Agenti utilizzati",
    "aiDescription": "Generato con AI",
    "aiDescriptionModel": "Modello AI",
    "aiDescriptionPrompt": "Prompt personalizzato",
    "allAgents": "Tutti gli agenti",
    "allChannels": "Tutti i canali",
    "allowedDomains": "Domini consentiti",
    "analysis": "Analisi",
    "analyzed": "Analisi",
    "anonymized": "Anonimizzata",
    "anonymous": "Anonimo",
    "answer": "Risposta",
    "answeringOnTheCall": "Sto rispondendo…",
    "apiKey": "API Key",
    "apiKeys": "API Key",
    "appearance": "Aspetto",
    "arrayOfObjects": "Array di oggetti",
    "assistantMessage": "Risposta assistente",
    "attachmentsNotImported": "Allegati non importati",
    "attempts": "Tentativi",
    "attention": "Attenzione",
    "audience": "Audience",
    "authentication": "Autenticazione",
    "auto": "Auto",
    "autoDetected": "Rilevati automaticamente",
    "autoProvisioning": "Auto provisioning",
    "autoProvisioningDescription": "Gli utenti che si autenticano tramite questi provider di identità o domini verranno automaticamente aggiunti alla tua organizzazione con il ruolo predefinito.",
    "autoRefreshError": "Errore",
    "autoRefreshOff": "In pausa",
    "autoRefreshOn": "Live",
    "autoRefreshStoppedErrors": "Aggiornamento automatico interrotto dopo errori ripetuti.",
    "autoRefreshStoppedUnavailable": "Aggiornamento automatico interrotto: questo contenuto non è più accessibile.",
    "autoRefreshWarning": "Attenzione",
    "availableCredit": "Saldo disponibile",
    "averageLine": "Media",
    "avgChatsPerUser": "Chat per user",
    "avgMessagesPerChat": "Messaggi per chat",
    "avgTime": "Tempo medio",
    "banned": "Bannato",
    "black": "Nero",
    "blocked": "Bloccato",
    "blockedDomains": "Domini bloccati",
    "blockedReasons": "Motivi di blocco",
    "body": "Testo",
    "botName": "Nome bot",
    "browserEngine": "Browser engine",
    "browsers": "Browser",
    "budgetTokens": "Budget token",
    "byChannel": "Per canale",
    "cached": "dalla cache",
    "calendarEvent": "Evento",
    "changePassword": "Cambia Password",
    "channel": "Canale",
    "channels": "Canali",
    "chat": "Chat",
    "chatCreatedAgo": "Creata",
    "chatOrigin": "Chat di origine",
    "chatStatistics": "Statistiche",
    "chatTypes": "Tipo di conversazione",
    "chatUpdatedAgo": "Ultimo messaggio",
    "chatWidget": "Chat Widget",
    "chunks": "Chunk",
    "clear": "Pulisci",
    "codeEditor": "Codice",
    "collapseContext": "Nascondi contesto",
    "comment": "Commento",
    "comparison": "Confronto",
    "completeName": "Nome e cognome",
    "completedAt": "Completata il",
    "configMcpServer": "Configura server MCP",
    "configure": "Configura",
    "confirm": "Conferma",
    "confirmPassword": "Conferma password",
    "confirmWithEmail": "Digita la tua email per confermare",
    "confirmWithPassword": "Inserisci la password per confermare",
    "connectMcpServer": "Connetti server MCP",
    "connectSubAgent": "Collega sotto-agente",
    "connectedAccounts": "Account collegati",
    "connectionChecking": "Verifica connessione...",
    "connectionConnected": "Connesso",
    "connectionError": "Errore di connessione",
    "connectionIdle": "Non verificato",
    "connectionStatus": "Connessione",
    "connectionTypes": "Connessione",
    "const": "Costante",
    "contactUs": "Contattaci",
    "content": "Contenuto",
    "contentPreview": "Anteprima contenuto",
    "conversationLengthBuckets": "Lunghezza conversazione",
    "conversationOutline": "Indice della conversazione",
    "conversations": "Conversazioni",
    "conversationsOverTime": "Conversazioni nel tempo",
    "cost": "Costo",
    "costByChannel": "Costo per canale",
    "costInUSD": "Costo in USD",
    "country": "Paese",
    "crawlMode": "Modalità Crawling",
    "createdAt": "Creato il",
    "createdBy": "Creato da",
    "credit": "Credito",
    "creditUpdatedAt": "Credito aggiornato il",
    "credits": "Crediti",
    "crmSync": "Sincronizzazione CRM",
    "curlExample": "Esempio cURL",
    "currentAgent": "Agente corrente",
    "currentPassword": "Password attuale",
    "currentSession": "Sessione corrente",
    "customCss": "CSS personalizzato",
    "customRange": "Personalizzato",
    "dailyUsage": "Utilizzo giornaliero",
    "dark": "Scuro",
    "darkModePreference": "Tema scuro",
    "dataLoadFailed": "Non è stato possibile caricare questo dato",
    "datetime": "Data / Ora",
    "day": "Giorno",
    "dayRateLimit": "Limite al giorno",
    "days": "{count} giorno | {count} giorni",
    "default": "Predefinito",
    "defaultMappingHint": "Se non viene configurata una mappatura, verrà utilizzata quella predefinita per il provider.",
    "defaultRole": "Ruolo predefinito",
    "deleted": "Eliminato",
    "deprecated": "Deprecato",
    "description": "Descrizione",
    "deselectAction": "Rimuovi",
    "details": "Dettagli",
    "device": "Dispositivo",
    "deviceContext": "Contesto dispositivo",
    "deviceType": "Tipo dispositivo",
    "diagram": "Diagramma",
    "disabled": "Disabilitato",
    "disallowPromptTraining": "Prompt Training disabilitato",
    "dismissableNotice": "Avviso",
    "documentPriority": "Priorità Documento",
    "documentType": "Tipo documento",
    "documents": "Documenti",
    "domainFilter": "Filtro domini",
    "downloadFile": "Scarica file",
    "downloading": "Download in corso",
    "duration": "Durata",
    "editApiTool": "Modifica API Tool",
    "editIntegration": "Modifica integrazione",
    "editMcpServer": "Modifica server MCP",
    "editSubAgent": "Modifica sotto-agente",
    "effectiveCredit": "Credito effettivo",
    "email": "Email",
    "emailClaim": "Claim email",
    "emailDomain": "Dominio email",
    "emailVerified": "Email verificata",
    "embed": "Incorpora",
    "embedCode": "Codice Embed",
    "enabled": "Abilitato",
    "enabledTools": "Tool abilitati",
    "endDate": "Data fine",
    "engagement": "Engagement",
    "enum": "Valori enum",
    "error": "Errore",
    "estimatedCost": "Costo stimato a fine mese",
    "estimatedCredit": "Credito stimato",
    "estimatedMonthlyCost": "Stima fine mese",
    "excludeDomains": "Domini esclusi",
    "expandContext": "Mostra più contesto",
    "expireIn": "Scade tra",
    "expires": "Scade",
    "expiresAt": "Scadenza",
    "exportMyData": "Esporta i miei dati",
    "externalAuth": "Autenticazione esterna",
    "externalAuthDescription": "Configura i provider di autenticazione esterna per consentire l'autenticazione tramite token JWT emessi da questi provider. Gli utenti autenticati tramite questi provider saranno aggiunti automaticamente alla tua organizzazione con il ruolo predefinito (auto provisioning).",
    "externalContext": "Contesto esterno",
    "externalContextSchema": "Schema contesto esterno",
    "externalId": "ID esterno (CRM)",
    "fallbackModels": "Modelli di fallback",
    "feedback": "Segnalazione",
    "feedbacks": "Feedback",
    "fieldMappingFallback": "Valore di default",
    "fieldMappingSource": "Campo sorgente",
    "fieldMappingTarget": "Campo destinazione {number}",
    "fieldMappingTransform": "Trasformazione",
    "fieldMappingTransformExtractDomainCompany": "Estrai azienda da dominio email",
    "fieldMappingTransformJoinArray": "Unisci array",
    "fieldMappingTransformMapValues": "Mappa valori",
    "fieldMappingTransformNone": "Nessuna",
    "fieldMappingTransformSplitFirstLast": "Dividi primo/ultimo",
    "fieldMappingValueMap": "Mappatura valori",
    "file": "File",
    "fileUpload": "Caricamento file",
    "fileUploadAllowedMimeTypes": "Tipi di file consentiti",
    "fileUploadEnabled": "Abilita caricamento file",
    "fileUploadMaxFileSize": "Dimensione massima file (MB)",
    "fileUploadMaxFilesPerChat": "File massimi per chat",
    "fileUploadMaxFilesPerMessage": "File massimi per messaggio",
    "files": "File",
    "filters": "Filtri",
    "floatingButtonPosition": "Posizione bottone",
    "folderName": "Nome cartella",
    "folders": "Cartelle",
    "followExternal": "Segui Link Esterni",
    "footer": "Footer",
    "forceOcr": "Forza OCR",
    "formMaxOptionsPerStep": "Opzioni massime consigliate",
    "formMaxSteps": "Step massimi consigliati",
    "frequencyPenalty": "Penalità di Frequenza",
    "freshnessBoost": "Boost Freschezza",
    "freshnessScale": "Scala temporale Freschezza",
    "freshnessWeight": "Peso Freschezza",
    "fullDuration": "Durata (ms)",
    "gallery": "Galleria ({count} immagini)",
    "gdprRequestType": {
      "conversations_erasure": "Cancellazione conversazioni",
      "erasure": "Cancellazione dati",
      "export": "Export dati"
    },
    "gdprRequests": "Richieste GDPR",
    "general": "Generale",
    "generateSchemaFromJson": "Genera schema da JSON",
    "goalOutcome": "Esito obiettivo",
    "granularity": "Granularità",
    "groupReasoningAgents": "Raggruppa",
    "hasRedundantChunks": "Ha Chunk Ridondanti",
    "header": "Header",
    "headers": "Headers",
    "healthCheckPath": "Health check",
    "hour": "Ora",
    "hourRateLimit": "Limite all'ora",
    "hsAccessToken": "Access Token",
    "hsAccessTokenHint": "Crea una Private App di HubSpot con i seguenti scope: crm.objects.contacts.read, crm.objects.contacts.write, crm.objects.owners.read.",
    "hsDefaultOwnerId": "Owner ID predefinito",
    "hsDefaultOwnerIdHint": "ID utente HubSpot a cui assegnare i contatti. Lasciare vuoto per non assegnare un owner.",
    "hsStaticProperties": "Proprietà statiche",
    "hsStaticPropertiesHint": "Proprietà fisse aggiunte ad ogni contatto.",
    "httpHeaderKey": "Chiave",
    "httpHeaderValue": "Valore",
    "httpHeaders": "Header HTTP",
    "iframe": "Iframe",
    "iframeCode": "Codice iframe",
    "imageLoadError": "Immagine non disponibile",
    "impersonated": "Impersonificato",
    "impersonation": "Impersonificazione",
    "importing": "Importazione in corso",
    "inRedis": "In Redis",
    "inStock": "Disponibile",
    "inTest": "In test",
    "includeDomains": "Domini inclusi",
    "includeThoughts": "Visualizza ragionamento",
    "indexStatus": "Stato indicizzazione",
    "info": "Info",
    "initialMessage": "Messaggio iniziale",
    "input": "Input",
    "inputSchema": "Schema di Input",
    "insertEmail": "Inserisci email",
    "integration": "Integrazione",
    "integrationConfig": "Configurazione",
    "integrationDisabled": "Disabilitata",
    "integrationEnabled": "Abilitata",
    "integrationFieldMapping": "Mappatura campi",
    "integrationProvider": "Provider",
    "integrationSyncLogs": "Log sincronizzazione",
    "integrationSyncLogsDescription": "La sincronizzazione avviene automaticamente alla creazione di un nuovo contatto.",
    "integrations": "Integrazioni",
    "interactiveLogin": "Mostra login/registrazione",
    "interface": "Interfaccia",
    "invitations": "Inviti",
    "ipAddress": "Indirizzo IP",
    "isAutoJoinEnabled": "Unisci automaticamente utenti già presenti con la stessa e-mail",
    "issuer": "Issuer",
    "itemsPerPage": "Per pagina",
    "jsonSample": "Esempio JSON",
    "jwksUrl": "JWKS URL",
    "key": "Chiave",
    "language": "Lingua",
    "languages": "Lingue",
    "last14Days": "Ultimi 14 giorni",
    "last30Days": "Ultimi 30 giorni",
    "last7Days": "Ultimi 7 giorni",
    "last90Days": "Ultimi 90 giorni",
    "lastActive": "Ultimo accesso",
    "lastActivity": "Ultima attività",
    "lastMonth": "Mese scorso",
    "lastRecalledAt": "Ultimo richiamo",
    "lastReconciledAt": "Ultimo allineamento",
    "lastRefillAt": "Ultima ricarica il",
    "lastSync": "Aggiornato il",
    "latest": "Ultima",
    "leadId": "ID interno",
    "left": "Sinistra",
    "light": "Chiaro",
    "limit": "Limite",
    "limitedStock": "Ultimi pezzi",
    "linkedAgents": "Agenti collegati",
    "llmIssues": "Problemi LLM",
    "loadDelay": "Ritardo caricamento (ms)",
    "loaderStrategy": "Strategia di caricamento",
    "loaderStrategyDynamicImport": "Dynamic Import",
    "loaderStrategyInlineModule": "Inline Module",
    "loaderStrategyScriptSrc": "Script Src",
    "locale": "Lingua",
    "location": "Posizione",
    "logo": "Logo",
    "logoUrl": "Logo URL",
    "mainColor": "Colore principale",
    "manageProfileDescription": "Modifica nome, password, avatar e altro",
    "maxDepth": "Profondità Massima",
    "maxMessageLength": "Lunghezza massima messaggio",
    "maxOutputTokens": "Token Massimi",
    "maxPages": "Pagine Massime",
    "maxResults": "Risultati massimi",
    "maxStepCount": "Numero Massimo di Step",
    "maxUses": "Utilizzi massimi",
    "mcpAuthType": "Tipo di autenticazione",
    "mcpServer": "Server MCP",
    "mcpServerUrl": "URL del server MPC",
    "mcpStatelessServer": "Client stateless",
    "memberSince": "Membro dal",
    "memories": "Memorie",
    "memory": "Memoria",
    "message": "Messaggio",
    "messageDetails": "Dettaglio messaggio",
    "messagePlaceholder": "Segnaposto",
    "messages": "Messaggi",
    "metadata": "Metadati",
    "method": "Metodo",
    "mimeTypeDocuments": "Documenti",
    "mimeTypeImages": "Immagini",
    "mimeTypeText": "Testo",
    "minuteRateLimit": "Limite al minuto",
    "mmr": "Maximal Marginal Relevance (MMR)",
    "mmrCandidatesLimit": "Limite Candidati MMR",
    "mmrDiversity": "Diversità MMR",
    "model": "Modello",
    "modelParameters": "Parametri modello",
    "month": "Mese",
    "monthRateLimit": "Limite al mese",
    "monthlyCost": "Costo mensile",
    "multipleChoiceAllowCustomAnswer": "Consenti risposta personalizzata",
    "multipleChoiceMaxOptions": "Numero massimo di opzioni",
    "name": "Nome",
    "nameClaim": "Claim nome",
    "never": "Mai",
    "newChat": "Nuova chat",
    "newPassword": "Nuova password",
    "no": "No",
    "noDataAvailable": "Nessun dato disponibile",
    "noDataRetention": "ZDR",
    "noFieldMapping": "Nessuna mappatura personalizzata configurata",
    "noIntegrations": "Nessuna integrazione configurata",
    "noPromptTraining": "No Prompt Training",
    "noSyncLogs": "Nessun log di sincronizzazione",
    "noTimingData": "Nessun dato. Effettua una richiesta di chat per vedere i log di timing.",
    "noTimingDataDesc": "Avvia una conversazione con un agente per vedere i log di timing qui in tempo reale.",
    "noTimingDataTitle": "Nessun dato disponibile",
    "notAvailable": "Non disponibile",
    "notConfigured": "Non configurata",
    "notConnected": "Non connesso",
    "notSynced": "Non sincronizzata",
    "notificationTitle": {
      "document_error": "Elaborazione documento fallita",
      "organization": {
        "created": "Organizzazione creata",
        "invite": "Invito organizzazione",
        "invite_accepted": "Invito accettato",
        "invite_rejected": "Invito rifiutato",
        "removed": "Rimosso dall'organizzazione"
      },
      "password_reset_requested": "È stata richiesta la reimpostazione della password"
    },
    "notificationType": {
      "api_key_expiring": "Scadenza API Key",
      "chat_blocked": "Chat bloccata",
      "chat_warning": "Avviso chat",
      "document_error": "Errore documento",
      "generic": "Generica",
      "organization": "Organizzazione",
      "password_reset_requested": "Reset password richiesto"
    },
    "oauthAuthorizationUrl": "URL di autorizzazione OAuth",
    "oauthClientId": "OAuth Client ID",
    "oauthClientSecret": "OAuth Client Secret",
    "oauthScopes": "Scopes OAuth",
    "oauthTokenUrl": "URL token OAuth",
    "ocrUsed": "OCR",
    "older": "Più vecchie",
    "onChannels": "WA · Teams",
    "openSource": "Apri sorgente",
    "operatingSystems": "Sistemi operativi",
    "or": "Oppure",
    "organization": "Organizzazione",
    "organizations": "Organizzazioni",
    "origin": "Origine",
    "originalMessage": "Risposta originale",
    "origins": "Sorgenti",
    "outOfStock": "Non disponibile",
    "output": "Output",
    "outputSchema": "Schema di Output",
    "pages": "Pagine",
    "passphrase": "Inserisci la parola chiave",
    "password": "Password",
    "peakHours": "Ore di punta",
    "period": "Periodo",
    "phaseBreakdown": "Breakdown fasi",
    "phone": "Telefono",
    "picture": "Immagine",
    "platformAssistant": "Assistente della piattaforma",
    "platformContext": "Contesto piattaforma",
    "postStreaming": "Post-streaming",
    "preStreaming": "Pre-streaming",
    "preferences": "Preferenze",
    "presencePenalty": "Penalità di Presenza",
    "preview": "Anteprima",
    "priority": "Priorità",
    "priority_1": "Molto Bassa",
    "priority_2": "Bassa",
    "priority_3": "Normale",
    "priority_4": "Alta",
    "priority_5": "Critica",
    "privacy": "Privacy",
    "privacyPolicyNotice": "Informativa privacy",
    "processedAt": "Processato il",
    "processing": "Elaborazione in corso...",
    "profile": "Profilo",
    "prompt": "Prompt",
    "properties": "Proprietà",
    "provider": "Provider",
    "providerOrganizationId": "ID Provider",
    "providerTimeoutMs": "Timeout provider (ms)",
    "qdrantSync": "Sync Vettoriale",
    "qrCode": "Codice QR",
    "question": "Domanda",
    "rateLimits": "Limiti di utilizzo",
    "read": "Letto",
    "reasoning": "Reasoning",
    "reasoningAgentTester": "Test Agente di Ragionamento",
    "reasoningDetails": "Dettagli di ragionamento",
    "reasoningEffort": "Intensità ragionamento",
    "reasoningSummary": "Riepilogo ragionamento",
    "redundantChunks": "Chunk ridondanti",
    "referrerDomains": "Domini di provenienza",
    "refillAmount": "Importo ricarica",
    "rememberMe": "Ricordami",
    "requestCount": "Richieste",
    "requestedAt": "Richiesta il",
    "requests": "Richieste",
    "requestsPerAgent": "Richieste per agente",
    "requestsUsed": "Richieste utilizzate",
    "required": "Obbligatorio",
    "requiredFields": "Campi obbligatori",
    "revisedMessage": "Risposta corretta",
    "right": "Destra",
    "riskScoreBands": "Fasce di rischio",
    "role": "Ruolo",
    "scheduledAt": "Programmata il",
    "schemaRootArray": "Array",
    "schemaRootObject": "Oggetto",
    "schemas": "Schemi",
    "screenCategories": "Risoluzione schermo",
    "searchAndExecution": "Ricerca ed esecuzione",
    "searchMode": "Modalità di Ricerca",
    "searchRecencyFilter": "Filtro temporale",
    "sectionChannelBreakdown": "Dettaglio per canale",
    "sectionConversationQuality": "Qualità conversazione",
    "sectionCostTrend": "Andamento costi mensili",
    "sectionDeviceContext": "Dispositivi e contesto (web e widget)",
    "sectionTraffic": "Traffico (web e widget)",
    "security": "Sicurezza",
    "selectAgent": "Seleziona agente",
    "selectedHint": "Selezionato",
    "sentiment": "Sentiment",
    "sentimentTrends": "Trend di sentiment",
    "serverInfo": "Info MCP server",
    "sessionExpiresIn": "Durata sessione (secondi)",
    "settings": "Impostazioni",
    "sfApiVersion": "Versione API",
    "sfClientId": "Client ID",
    "sfClientSecret": "Client Secret",
    "sfExternalIdField": "Campo ID esterno",
    "sfInstanceUrl": "Instance URL",
    "shareWith": "Condividi con gli agenti",
    "showExtendedSteps": "Mostra i passaggi",
    "showing": "Mostrati",
    "similarity": "Similarità",
    "sitemapUrl": "URL Sitemap",
    "size": "Dimensione",
    "slowest": "Più lento",
    "slug": "Slug",
    "smartRanking": "Ranking Intelligente",
    "smoothStream": "Smooth streaming",
    "source": "Sorgente",
    "sources": "Fonti",
    "spokenExchange": "Scambiato a voce",
    "startDate": "Data inizio",
    "startUrl": "URL di Partenza",
    "status": "Stato",
    "steps": "step",
    "streaming": "Streaming",
    "style": "Stile",
    "subAgent": "Sotto-agente",
    "subject": "Oggetto",
    "syncStatus": "Stato",
    "targetAll": "Tutti gli utenti",
    "targetOrganization": "Organizzazione",
    "targetType": "Destinatario",
    "targetUser": "Utente specifico",
    "teams": "Microsoft Teams",
    "teamsAccentColor": "Colore del tema",
    "teamsAppId": "App ID (Microsoft)",
    "teamsAppPassword": "App password / client secret",
    "teamsAppTenantId": "Tenant ID",
    "teamsAppType": "Tipo app",
    "teamsAppVersion": "Versione app",
    "teamsDescriptionFull": "Descrizione completa",
    "teamsDescriptionShort": "Descrizione breve",
    "teamsDeveloperName": "Nome sviluppatore",
    "teamsManifestDetails": "Dettagli dell'app (mostrati in Teams)",
    "temperature": "Temperatura",
    "testConnection": "Verifica connessione",
    "testPlayground": "Test Playground",
    "textColor": "Colore del testo",
    "theme": "Tema",
    "thinking": "Pensiero",
    "thinkingBudget": "Budget ragionamento",
    "thinkingDisplay": "Visualizza ragionamento",
    "thinkingEffort": "Intensità ragionamento",
    "thinkingLevel": "Livello ragionamento",
    "thinkingType": "Tipo pensiero",
    "thisMonth": "Questo mese",
    "timelineSteps": "Timeline steps",
    "timeoutMs": "Timeout (ms)",
    "timezoneRegions": "Fuso orario",
    "title": "Titolo",
    "today": "Oggi",
    "tokens": "token",
    "tool": "Tool",
    "toolApprovalBadge": "Conferma utente",
    "toolName": "Nome del tool: {name}",
    "toolRequiresApproval": "Chiedi conferma all'utente",
    "tools": "Tool",
    "topPages": "Pagine principali",
    "topTopics": "Trending topics",
    "total": "Totale",
    "totalConversations": "Chat in totale",
    "totalCost": "Costo totale",
    "totalItemsCount": "Elementi: {total}",
    "totalMessages": "Messaggi in totale",
    "totalPages": "di {total}",
    "trustedOrigins": "Origini attendibili",
    "tuning": "Tuning",
    "type": "Tipo",
    "typeMain": "Main",
    "typeSub": "Sub",
    "uniqueUsers": "Utenti unici",
    "unitChat": "chat",
    "unitChatPerUser": "chat",
    "unitMessages": "messaggi",
    "unitMessagesPerChat": "messaggi",
    "unitUsers": "utenti",
    "unknown": "Sconosciuto",
    "unread": "Non letto",
    "updateProfile": "Aggiorna profilo",
    "updatedAt": "Aggiornato il",
    "upload": "Carica {index}/{total}",
    "url": "URL pagina web",
    "usage": "Utilizzo",
    "useBrowserEngine": "Utilizza il browser",
    "useExtractionStrategy": "Utilizza l'AI",
    "user": "Utente",
    "userInput": "Opzione selezionata",
    "userPrompt": "Richiesta utente",
    "userQuestion": "Domanda",
    "userTones": "Tono utente",
    "users": "Utenti",
    "value": "Valore",
    "version": "Versione",
    "video": "Video",
    "viewPdfPage": "Visualizza pagina PDF",
    "visibility": "Visibilità",
    "visualEditor": "Visuale",
    "voice": "Voce",
    "voiceCascadeTimeoutSeconds": "Tempo massimo per rispondere (secondi)",
    "voiceEnabled": "Conversazione vocale",
    "voiceFillerAfterSeconds": "Riempitivo dopo (secondi)",
    "voiceFillerMessage": "Frase di attesa",
    "voiceFirstMessage": "Frase di apertura",
    "voiceId": "Voce",
    "voiceIgnoreBackgroundVoices": "Ignora le voci di sottofondo",
    "voiceLanguage": "Lingua parlata",
    "voiceMaxSessionSeconds": "Durata massima sessione (secondi)",
    "voiceTurnEagerness": "Fine del turno",
    "voiceTurnTimeoutSeconds": "Pausa prima di riprendere la parola (secondi)",
    "vote": "Voto",
    "warnings": "Avvisi",
    "webSearch": "Ricerca web",
    "webSearchEnabled": "Abilita ricerca web",
    "webSearchNative": "Nativa",
    "webSearchProvider": "Provider di ricerca",
    "webhookUrl": "URL Webhook",
    "week": "Settimana",
    "welcome": "Benvenuto in {appName}!",
    "whatsapp": "WhatsApp",
    "whatsappAccessToken": "Access token",
    "whatsappAppSecret": "App secret",
    "whatsappPhoneNumberId": "Phone number ID",
    "whatsappVerifyToken": "Verify token",
    "white": "Bianco",
    "widgetUrl": "URL widget",
    "year": "Anno",
    "yes": "Sì",
    "yesterday": "Ieri",
    "zeroDataRetention": "Zero Data Retention (ZDR)"
  },
  "language": {
    "de": "Tedesco",
    "en": "Inglese",
    "english": "Inglese",
    "es": "Spagnolo",
    "fr": "Francese",
    "french": "Francese",
    "german": "Tedesco",
    "it": "Italiano",
    "italian": "Italiano",
    "nl": "Olandese",
    "pt": "Portoghese",
    "spanish": "Spagnolo"
  },
  "lead": {
    "contactReason": {
      "appointment": "Appuntamento",
      "callback_request": "Richiesta di richiamata",
      "complaint": "Reclamo",
      "info_request": "Richiesta informazioni",
      "other": "Altro",
      "quote_request": "Richiesta preventivo",
      "support": "Supporto"
    },
    "label": {
      "budget": "Budget",
      "company": "Azienda",
      "contactReason": "Motivo del contatto",
      "conversationSummary": "Riepilogo conversazione",
      "preferredContactMethod": "Metodo di contatto preferito",
      "preferredContactTime": "Orario di contatto preferito",
      "productInterest": "Prodotto di interesse",
      "sentiment": "Sentiment",
      "topics": "Argomenti",
      "urgency": "Urgenza"
    },
    "preferredContactMethod": {
      "any": "Qualsiasi",
      "email": "Email",
      "phone": "Telefono",
      "whatsapp": "WhatsApp"
    },
    "preferredContactTime": {
      "afternoon": "Pomeriggio",
      "any": "Qualsiasi",
      "evening": "Sera",
      "morning": "Mattina"
    },
    "sentiment": {
      "excited": "Entusiasta",
      "frustrated": "Frustrato",
      "negative": "Negativo",
      "neutral": "Neutro",
      "positive": "Positivo"
    },
    "urgency": {
      "high": "Alta",
      "low": "Bassa",
      "medium": "Media"
    }
  },
  "mcpAuthType": {
    "headers": "Intestazioni HTTP (API Key)",
    "oauth": "OAuth 2.0 per utente"
  },
  "mcpServerStatus": {
    "active": "Attivo",
    "error": "Errore",
    "inactive": "Inattivo"
  },
  "member": {
    "agentAccess": {
      "hint": "Lascia vuoto per consentire al membro di usare tutti gli agenti dell'organizzazione. Seleziona degli agenti per limitarlo solo a quelli.",
      "managerHint": "Owner e admin possono usare tutti gli agenti; il loro accesso non può essere limitato."
    }
  },
  "memorySource": {
    "explicit": "Esplicita | Esplicite",
    "extracted": "Estratta | Estratte"
  },
  "message": {
    "accountLinkEmailMismatch": "Puoi collegare solo account che usano la stessa email del tuo profilo.",
    "accountLinkError": "Impossibile collegare l'account. Riprova.",
    "accountUnlinked": "Account disconnesso",
    "agentAccessDenied": "Non hai accesso a questo agente",
    "agentAccessDeniedAction": "Vedi gli agenti disponibili",
    "agentActivated": "Agente attivato con successo",
    "agentDeactivated": "Agente disattivato con successo",
    "agentNotFound": "Agente non trovato",
    "agentsEmpty": "Nessun agente. Crea il primo per iniziare.",
    "analyzeChatSuccess": "Conversazione analizzata con successo",
    "apiToolsEmpty": "Nessun API tool. Aggiungi il primo per far chiamare all'agente un servizio esterno.",
    "banSuccess": "Utente bannato con successo",
    "blockChatSuccess": "Conversazione bloccata con successo",
    "bulkUnlinkAllDeleteConfirm": "{count} documenti verranno eliminati definitivamente perché non hanno altri agenti collegati. Vuoi procedere?",
    "bulkUnlinkMixedConfirm": "{unlinkCount} documenti verranno disassociati e {deleteCount} verranno eliminati definitivamente (non hanno altri agenti collegati). Vuoi procedere?",
    "cancelInvitationConfirm": "Sei sicuro di voler annullare l'invito per {email}?",
    "cancelInvitationSuccess": "Invito annullato con successo",
    "chatAnonymized": "Il contenuto di questa conversazione è stato cancellato (GDPR): restano solo le metriche aggregate.",
    "chatErrorBadRequest": "Si è verificato un errore con la richiesta. Inizia una nuova chat per continuare.",
    "chatErrorContextWindow": "La conversazione è diventata troppo lunga. Inizia una nuova chat per continuare.",
    "chatErrorConversationBlocked": "Questa conversazione è stata bloccata per violazione delle policy.",
    "chatErrorCreditExhausted": "Servizio non disponibile. Riprova più tardi.",
    "chatErrorGatewayPromptTraining": "Il modello \"{model}\" non supporta l'opzione \"Disabilita addestramento prompt\". Disattiva questa impostazione nella configurazione del gateway dell'agente oppure scegli un modello compatibile.",
    "chatErrorGatewayZdr": "Il modello \"{model}\" non supporta l'opzione \"Zero Data Retention\". Disattiva ZDR nella configurazione del gateway dell'agente oppure scegli un modello compatibile.",
    "chatErrorGeneric": "Errore durante la richiesta. Se il problema persiste inizia una nuova chat. Riprovo tra {seconds}...",
    "chatErrorInternalServer": "Si è verificato un errore del server. Inizia una nuova chat per continuare.",
    "chatErrorNotFound": "La conversazione non è più disponibile. Inizia una nuova chat per continuare.",
    "chatErrorOriginNotAllowed": "L'origine della richiesta non è consentita. Contatta l'amministratore del sistema.",
    "chatErrorRateLimit": "Il limite di richieste è stato superato. Riprovo tra {seconds} secondi...",
    "chatErrorRetrying": "Riprovo tra {seconds} secondi...",
    "checkYourEmail": "Verifica la tua casella email",
    "clearTimingLogsConfirm": "Svuotare tutti i log di timing?",
    "confirm": "Sei sicuro di voler procedere?",
    "confirmRefillCredits": "Sei sicuro di voler ricaricare il credito di {amount}?",
    "contentTruncated": "Contenuto troncato. Totale caratteri: {total}",
    "copied": "Copiato negli appunti",
    "crawlError": "Errore durante il crawling",
    "createFolderSuccess": "Cartella creata con successo",
    "defaultAgentWelcome": "Ciao! Come posso aiutarti oggi?",
    "defaultPrivacyPolicyNotice": "Inviando la richiesta accetti la nostra [Privacy Policy](https://www.iubenda.com/privacy-policy/46350192).",
    "deleteAllMemoriesConfirm": "Tutte le memorie di questo utente verranno eliminate definitivamente, anche dalla ricerca semantica. Vuoi procedere?",
    "deleteAllNotificationsConfirm": "Sei sicuro di voler eliminare tutte le notifiche?",
    "deleteBulkDocumentConfirm": "Sei sicuro di voler eliminare i documenti selezionati? Verranno rimossi da tutti gli agenti collegati.",
    "deleteDocumentConfirm": "Sei sicuro di voler eliminare questo documento? Verrà rimosso da tutti gli agenti collegati.",
    "deleteDocumentConfirmWithAgents": "Sei sicuro di voler eliminare questo documento? Verrà rimosso dai seguenti agenti:{agents}",
    "deleteError": "Eliminazione non riuscita. Riprova.",
    "deleteFolderConfirm": "Sei sicuro di voler eliminare questa cartella? Tutti i documenti al suo interno verranno rimossi dall'agente.",
    "deleteFolderSuccess": "Cartella eliminata con successo",
    "deleteMyConversationsConfirm": "Sei sicuro di voler cancellare definitivamente tutte le tue conversazioni? Questa azione non può essere annullata.",
    "deleteNotificationConfirm": "Sei sicuro di voler eliminare questa notifica?",
    "deleteProfileBlockedSoleOwner": "Sei l'unico proprietario di {organizations}. Trasferisci la proprietà o elimina le organizzazioni prima di poter eliminare l'account.",
    "deleteProfileConfirm": "Stai per eliminare definitivamente il tuo account: il profilo verrà anonimizzato e il contenuto delle tue conversazioni cancellato. Questa azione non può essere annullata.",
    "deleteProfileDescription": "Anonimizza il tuo account e cancella il contenuto delle tue conversazioni (diritto all'oblio).",
    "diagramRenderError": "Impossibile renderizzare il diagramma.",
    "documentsEmpty": "Questa cartella è ancora vuota. Aggiungi documenti dal menu Crea, oppure inizia con una cartella.",
    "empty": "Nessun elemento trovato",
    "endpointActivated": "Endpoint attivato con successo",
    "endpointDeactivated": "Endpoint disattivato con successo",
    "endpointsEmpty": "Nessun endpoint. Crea il primo per esporre l'agente via HTTP.",
    "error": "Errore",
    "exportError": "Errore durante l'esportazione dei dati",
    "exportFailed": "L'esportazione dei dati non è riuscita. Riprova più tardi.",
    "exportMyDataDescription": "Scarica una copia completa dei tuoi dati personali in formato ZIP (Art. 15 e 20 GDPR).",
    "exportRequested": "Stiamo preparando il tuo archivio: riceverai un'email con il link per scaricarlo.",
    "exportSuccess": "CSV esportato con successo",
    "feedbackSubmitError": "Invio fallito. Riprova per favore.",
    "feedbackSubmittedMessage": "Il tuo feedback è stato inviato con successo.",
    "feedbackSubmittedTitle": "Grazie!",
    "feedbacksEmpty": "I feedback che gli utenti lasciano sulle risposte dell'agente compariranno qui.",
    "fileAlreadyImported": "Già importato",
    "fileAlreadyImportedExistingList": "I seguenti file sono già presenti nell'organizzazione:\n{names}",
    "fileAlreadyImportedLink": "Questo file è già stato importato. Vuoi collegarlo all'agente corrente o creare un nuovo documento?",
    "fileAlreadyImportedNewList": "I seguenti file sono nuovi e verranno importati normalmente:\n{names}",
    "fileAlreadyImportedQuestion": "Vuoi collegare i file già presenti all'agente corrente?",
    "fileAlreadyLinkedToAgent": "I seguenti file sono già collegati all'agente corrente:\n{names}",
    "fileLimitPerChat": "Hai raggiunto il limite di {max} file per questa conversazione.",
    "fileLimitPerMessage": "Puoi allegare al massimo {max} file per messaggio.",
    "formRenderError": "Non è stato possibile mostrare il modulo. Chiedilo di nuovo e l'assistente lo invierà.",
    "geolocationPermissionDenied": "Accesso alla posizione negato. Consentilo nelle impostazioni del browser.",
    "geolocationUnavailable": "Posizione non disponibile. Riprova o inserisci la posizione manualmente.",
    "getMcpServerInfoError": "Un errore è avvenuto durante il caricamento dei tool.",
    "importError": "Errore durante l'importazione",
    "importSuccess": "{count} documenti importati con successo",
    "importing": "Importazione in corso...",
    "insufficientCredit": "Credito insufficiente. Riprova più tardi.",
    "insufficientCreditMessage": "Il tuo credito è insufficiente per completare questa operazione. Contatta l'amministratore del sistema per ulteriori informazioni.",
    "integrationCreated": "Integrazione creata con successo",
    "integrationDeleted": "Integrazione eliminata con successo",
    "integrationDisabled": "Integrazione disabilitata",
    "integrationEnabled": "Integrazione abilitata",
    "integrationTestFailed": "Verifica connessione fallita: {error}",
    "integrationTestSuccess": "Connessione verificata con successo",
    "integrationUpdated": "Integrazione aggiornata con successo",
    "invalidJson": "L'input non è un JSON valido",
    "invitationAccepted": "Invito accettato",
    "invitationAlreadyHandled": "Invito già gestito",
    "invitationDeclined": "Invito declinato",
    "invitationToJoinOrganization": "Sei stato invitato a unirti a",
    "invitationsEmpty": "Nessun invito in sospeso. Invita le persone dalla pagina dei membri.",
    "leadSubmitError": "Invio fallito. Riprova per favore.",
    "leadSubmittedMessage": "La richiesta è stata inviata con successo.",
    "leadSubmittedTitle": "Grazie!",
    "leadsEmpty": "I lead raccolti dall'agente durante le conversazioni compariranno qui.",
    "leftOrganization": "Hai lasciato l'organizzazione con successo",
    "loadConversationsError": "Impossibile caricare le conversazioni",
    "loading": "Caricamento...",
    "loadingError": "Errore durante il caricamento",
    "mcpServerCheckError": "Errore durante la verifica del server MCP: {error}",
    "mcpServerCheckSuccess": "Verifica del server MCP riuscita",
    "mcpServerInvalidEndpoint": "Questo URL non punta a un endpoint MCP: il server ha risposto con una pagina web. Controlla il percorso, di solito i server MCP lo espongono sotto /mcp.",
    "mcpServersEmpty": "Nessun server MCP. Collega il primo per dare nuovi strumenti all'agente.",
    "membersEmpty": "Nessun membro. Invita il primo per iniziare.",
    "memoriesEmpty": "Le memorie che l'agente salva su questo utente durante le conversazioni compariranno qui.",
    "memoryNotSynced": "Memoria non sincronizzata con la ricerca semantica: non viene considerata nelle risposte finché lo sweep di riparazione non la ripristina.",
    "moveDocumentSuccess": "Documento spostato con successo",
    "noActiveSessions": "Nessuna altra sessione attiva",
    "noChats": "Nessuna chat disponibile",
    "noConnectedAccounts": "Nessun account collegato",
    "noConversations": "Nessuna conversazione trovata",
    "noConversationsHint": "Inizia una nuova chat per vederla comparire qui.",
    "noCreditsData": "Nessun dato crediti disponibile",
    "noEndpointLogs": "Nessun log endpoint disponibile",
    "noLinkedAgents": "Nessun agente collegato",
    "noNotifications": "Nessuna notifica",
    "noOptions": "Nessun elemento",
    "noResults": "Nessun risultato trovato",
    "noSearchResults": "Nessun elemento corrisponde alla ricerca. Cancellala per vedere tutto.",
    "notificationsEmpty": "Nessuna notifica inviata. Crea la prima per raggiungere i tuoi utenti.",
    "oauthConfigIncomplete": "Configurazione OAuth incompleta. Imposta il Client ID nelle impostazioni del server MCP.",
    "oauthConnected": "Autorizzazione OAuth completata con successo",
    "oauthError": "Errore durante l'autorizzazione OAuth",
    "organizationMembersEmpty": "Nessun membro. Aggiungi il primo per iniziare.",
    "organizationNotSelected": "Nessuna organizzazione selezionata",
    "organizationsEmpty": "Nessuna organizzazione. Crea la prima per iniziare.",
    "pageNotFound": "Pagina non trovata",
    "passwordChangeSuccess": "Password cambiata con successo",
    "passwordResetSuccess": "Password reimpostata con successo",
    "readError": "Errore durante la lettura",
    "reasoningAgent": "Questo è un agente di ragionamento. Non è progettato per mantenere la storia della conversazione, ogni messaggio è processato indipendentemente.",
    "recoverPasswordSuccess": "Email di recupero inviata con successo",
    "refillFailed": "Ricarica fallita. Riprova più tardi.",
    "refillSuccess": "Ricarica completata con successo",
    "refreshSuccess": "Aggiornamento completato con successo",
    "releaseNotesEmpty": "Nessuna nota di rilascio pubblicata. Gli aggiornamenti compariranno qui man mano che escono.",
    "removeSuccess": "Eliminazione completata con successo",
    "renameFolderSuccess": "Cartella rinominata con successo",
    "revisedAnswersEmpty": "Nessuna risposta revisionata. Crea la prima per insegnare all'agente una risposta migliore.",
    "selectedCount": "{count} di {total} selezionati",
    "sendInvitationConfirm": "Sei sicuro di voler inviare nuovamente l'invito a {email}?",
    "sessionRevoked": "Sessione disconnessa",
    "sessionsEmpty": "Un accesso da un altro dispositivo o browser apre una nuova sessione, elencata qui.",
    "sharedSuccess": "Documento condiviso con successo",
    "sitemapUrlRequired": "L'URL della sitemap è richiesto",
    "startUrlRequired": "L'URL di partenza è richiesto",
    "subAgentsEmpty": "Collega un agente per delegargli una parte della conversazione.",
    "submitError": "Errore durante il salvataggio",
    "submitSuccess": "Salvataggio completato con successo",
    "success": "Successo",
    "testExecutionError": "Errore nell'esecuzione del test",
    "toolNameAutoGenerated": "Il nome del tool verrà generato in automatico",
    "typeToSearch": "Inizia a digitare per cercare...",
    "unauthorized": "Non hai i permessi per gestire i canali.",
    "unbanSuccess": "Utente sbannato con successo",
    "unblockChatSuccess": "Conversazione sbloccata con successo",
    "unlinkAgentConfirm": "Sei sicuro di voler rimuovere questo agente dal documento? Il documento rimarrà disponibile per gli altri agenti collegati.",
    "unlinkDocumentConfirm": "Sei sicuro di voler disassociare questo documento dall'agente? Il documento rimarrà disponibile per gli altri agenti collegati.",
    "unlinkLastAgentDeleteConfirm": "Questo è l'ultimo agente collegato a questo documento. Rimuovendolo il documento verrà eliminato definitivamente. Vuoi procedere?",
    "unlinkSuccess": "Documento disassociato con successo",
    "urlAlreadyImported": "Già importato",
    "urlAlreadyImportedLink": "Questo URL è già stato importato. Vuoi collegarlo all'agente corrente?",
    "userChatsEmpty": "Le conversazioni di questo utente con qualsiasi agente compariranno qui.",
    "userOrganizationsEmpty": "L'utente non appartiene ancora a nessuna organizzazione. Aggiungi la prima.",
    "userUpdateSuccess": "Profilo utente aggiornato con successo",
    "usersEmpty": "Nessun utente. Crea il primo per iniziare.",
    "voiceCancelled": "Ho annullato.",
    "voiceConfirmed": "Confermo.",
    "voiceConnecting": "Connessione…",
    "voiceConnectionDone": "Ho completato il collegamento.",
    "voiceFailed": "La sessione vocale si è interrotta",
    "voiceInterrupted": "Riprova, oppure continua per iscritto.",
    "voiceListening": "In ascolto",
    "voiceLocationRefused": "Preferisco non condividere la mia posizione.",
    "voiceLocationShared": "La mia posizione è {place}.",
    "voiceMuted": "Microfono disattivato",
    "voiceNoAnswer": "L'agente non è riuscito a produrre una risposta per questa chiamata. Riprova, oppure continua per iscritto.",
    "voiceSpeaking": "L'agente sta parlando",
    "voiceTookTooLong": "La risposta ha impiegato troppo tempo per la chiamata. Riprova, oppure continua per iscritto: la risposta comparirà qui appena pronta.",
    "warning": "Attenzione"
  },
  "messagePart": {
    "expandChunkContext": "Lettura di altro contesto...",
    "fetchTeamsChannelHistory": "Lettura cronologia canale...",
    "geocode": "Ricerca della posizione...",
    "getWeather": "Recupero dati meteo...",
    "readDocumentFile": "Lettura del documento originale...",
    "reasoning": "Ragionamento...",
    "recallUserMemory": "Richiamo dei ricordi utente...",
    "requestGeolocation": "Richiesta posizione...",
    "requestOAuthConnection": "Connessione in corso...",
    "requestOAuthConnectionButton": "Connetti {name}",
    "requestOAuthConnectionInfo": "Richiesta autorizzazione per accedere i dati di {name}.",
    "requestOAuthConnectionPrompt": "Per accedere ai dati di {name} è necessario autorizzare la connessione.",
    "requestOAuthConnectionSuccess": "Connessione a {name} riuscita.",
    "revisedAnswers": "Ricerca nelle domande ricorrenti...",
    "runSubagent": "Delega a un sotto-agente...",
    "runWorker": "Delega a un worker...",
    "saveUserMemory": "Aggiornamento memoria utente...",
    "searchingDocuments": "Ricerca nella memoria...",
    "showArtifact": "Preparazione contenuto...",
    "showCalendarEvent": "Creazione evento calendario...",
    "showComparison": "Costruzione confronto...",
    "showContactForm": "Creazione modulo contatto...",
    "showDiagram": "Generazione diagramma...",
    "showEmail": "Composizione email...",
    "showForm": "Creazione form...",
    "showImageGallery": "Caricamento galleria...",
    "showLocation": "Caricamento posizione...",
    "showMessage": "Composizione messaggio...",
    "showMultipleChoice": "Mostro le opzioni...",
    "showProducts": "Caricamento prodotti...",
    "showQrCode": "Generazione codice QR...",
    "showSources": "Caricamento fonti...",
    "showSuggestedReply": "Suggerisco una risposta...",
    "showVideo": "Caricamento video...",
    "showWeather": "Caricamento previsioni...",
    "showWebPages": "Caricamento pagine...",
    "stepCount": "{n} passaggio | {n} passaggi",
    "stepDocument": "Documento",
    "stepDropped": "{n} query esclusa: oltre il limite | {n} query escluse: oltre il limite",
    "stepError": "Errore",
    "stepExcerpts": "{n} estratto | {n} estratti",
    "stepInput": "Input",
    "stepItems": "{n} elemento | {n} elementi",
    "stepNoResults": "Nessun risultato trovato",
    "stepOutput": "Output",
    "stepRepeated": "{n} estratto già trovato prima | {n} estratti già trovati prima",
    "stepTimedOut": "{n} ricerca non ha risposto in tempo: i risultati possono essere incompleti | {n} ricerche non hanno risposto in tempo: i risultati possono essere incompleti",
    "steps": "Elaborazione",
    "streaming": "Caricamento...",
    "tool": "Esecuzione di un tool...",
    "webSearch": "Ricerca sul web..."
  },
  "models": {
    "claude-fable-5": "Claude Fable 5",
    "claude-fable-51": "Claude Fable 5.1",
    "claude-haiku-45": "Claude Haiku 4.5",
    "claude-opus-46": "Claude Opus 4.6",
    "claude-opus-47": "Claude Opus 4.7",
    "claude-opus-48": "Claude Opus 4.8",
    "claude-opus-5": "Claude Opus 5",
    "claude-opus-5-fast": "Claude Opus 5 Fast",
    "claude-sonnet-46": "Claude Sonnet 4.6",
    "claude-sonnet-5": "Claude Sonnet 5",
    "deepseek-v32": "Deepseek v3.2",
    "deepseek-v32-thinking": "Deepseek v3.2 Thinking",
    "deepseek-v4": "Deepseek v4.0",
    "deepseek-v4-flash": "Deepseek v4.0 Flash",
    "deepseek-v4-flash-0731": "Deepseek v4.0 Flash 0731",
    "deepseek-v4-pro": "Deepseek v4.0 Pro",
    "gemini-25-flash": "Gemini 2.5 Flash",
    "gemini-25-flash-lite": "Gemini 2.5 Flash Lite",
    "gemini-25-pro": "Gemini 2.5 Pro",
    "gemini-3-flash": "Gemini 3 Flash",
    "gemini-3-pro-preview": "Gemini 3 Pro Preview",
    "gemini-31-flash-lite": "Gemini 3.1 Flash Lite",
    "gemini-31-flash-lite-preview": "Gemini 3.1 Flash Lite Preview",
    "gemini-31-pro-preview": "Gemini 3.1 Pro Preview",
    "gemini-35-flash": "Gemini 3.5 Flash",
    "gemini-35-flash-lite": "Gemini 3.5 Flash Lite",
    "gemini-36-flash": "Gemini 3.6 Flash",
    "gemini-37-flash": "Gemini 3.7 Flash",
    "gemini-38-flash": "Gemini 3.8 Flash",
    "glm-52": "GLM 5.2",
    "glm-52-fast": "GLM 5.2 Fast",
    "glm-53": "GLM 5.3",
    "glm-53-fast": "GLM 5.3 Fast",
    "glm-53-flash": "GLM 5.3 Flash",
    "glm-53-promo-50": "GLM 5.3 Promo 50%",
    "gpt-5-mini": "ChatGPT 5 Mini",
    "gpt-5-nano": "ChatGPT 5 Nano",
    "gpt-51-instant": "ChatGPT 5.1 Instant",
    "gpt-51-thinking": "ChatGPT 5.1 Thinking",
    "gpt-52": "ChatGPT 5.2",
    "gpt-52-chat": "ChatGPT 5.2 Chat",
    "gpt-54": "ChatGPT 5.4",
    "gpt-54-mini": "ChatGPT 5.4 Mini",
    "gpt-54-nano": "ChatGPT 5.4 Nano",
    "gpt-54-pro": "ChatGPT 5.4 Pro",
    "gpt-55": "ChatGPT 5.5",
    "gpt-55-pro": "ChatGPT 5.5 Pro",
    "gpt-56-luna": "ChatGPT 5.6 Luna",
    "gpt-56-luna-fast": "ChatGPT 5.6 Luna Fast",
    "gpt-56-sol": "ChatGPT 5.6 Sol",
    "gpt-56-sol-fast": "ChatGPT 5.6 Sol Fast",
    "gpt-56-terra": "ChatGPT 5.6 Terra",
    "gpt-56-terra-fast": "ChatGPT 5.6 Terra Fast",
    "gpt-6-astra": "ChatGPT 6 Astra",
    "gpt-6-astra-fast": "ChatGPT 6 Astra Fast",
    "grok-43": "Grok 4.3",
    "grok-46": "Grok 4.6",
    "kimi-k3": "Kimi K3",
    "kimi-k3-fast": "Kimi K3 Fast",
    "muse-spark-11": "Muse Spark 1.1",
    "muse-spark-12": "Muse Spark 1.2",
    "qwen36-plus": "Qwen 3.6 Plus",
    "qwen37-flash": "Qwen 3.7 Flash",
    "qwen37-max": "Qwen 3.7 Max",
    "qwen37-plus": "Qwen 3.7 Plus",
    "qwen38-27b": "Qwen 3.8 27B",
    "qwen38-max": "Qwen 3.8 Max",
    "qwen38-max-0902": "Qwen 3.8 Max 0902"
  },
  "placeholder": {
    "apiToolName": "es. get-product-availability",
    "apiToolUrl": "https://api.example.com/resource/{param}",
    "askAnything": "Scrivi la tua domanda...",
    "autoDetect": "Rileva automaticamente",
    "autoGenerated": "Generata automaticamente se lasciato vuoto",
    "comment": "Scrivi il tuo commento...",
    "completeName": "Inserisci nome e cognome",
    "constValue": "Valore costante",
    "customAnswer": "Scrivi la tua risposta...",
    "description": "Inserisci la descrizione",
    "documentContent": "Inserisci il contenuto del documento",
    "documentName": "Inserisci il nome del documento",
    "documentUrl": "Inserisci l'URL della pagina web da importare",
    "email": "Inserisci l'indirizzo email",
    "endDate": "Seleziona data fine",
    "enterYourQuestion": "Inserisci la tua domanda...",
    "insert": "Inserisci...",
    "insertOrigin": "https://example.com",
    "limit": "Inserisci il limite",
    "loading": "Caricamento...",
    "mcpServerHealthCheckPath": "Inserisci l'endpoint per il controllo dello stato",
    "mcpServerUrl": "Inserisci l'URL del server MCP",
    "model": "Seleziona il modello",
    "name": "Inserisci il nome",
    "noTrustedOrigins": "Nessuna origine attendibile configurata",
    "oauthAuthorizationUrl": "es. https://provider.com/oauth/authorize",
    "oauthClientId": "es. my-client-app",
    "oauthClientSecret": "Inserisci il client secret",
    "oauthScopes": "es. read:contacts write:contacts",
    "oauthTokenUrl": "es. https://provider.com/oauth/token",
    "pages": "1, 4, 6, 8-12",
    "pasteJsonSample": "Incolla un esempio JSON per generare lo schema",
    "phone": "Inserisci il numero di telefono",
    "prompt": "Inserisci il prompt",
    "request": "Richiesta...",
    "search": "Cerca...",
    "secretEdit": "Lascia vuoto per mantenere il secret attuale",
    "select": "Seleziona",
    "selectAgent": "Seleziona un agente",
    "selectLanguage": "Seleziona lingua",
    "selectPriority": "Seleziona priorità",
    "similarity": "Inserisci la similarità",
    "sitemapUrl": "https://example.com/sitemap.xml",
    "slug": "Inserisci lo slug",
    "startDate": "Seleziona data inizio",
    "startUrl": "https://example.com",
    "temperature": "Inserisci la temperatura",
    "title": "Inserisci il titolo",
    "uploadFile": "Carica un file"
  },
  "problems": {
    "conflict": "Si è verificato un conflitto. La risorsa potrebbe già esistere.",
    "conversation-blocked": "Questa conversazione è stata bloccata.",
    "credit-exhausted": "Crediti esauriti. Contatta l'amministratore.",
    "entity-not-found": "Risorsa non trovata o disabilitata.",
    "file-upload-disabled": "Il caricamento file non è abilitato per questo agente.",
    "file-upload-validation": "File non valido: verifica dimensione, tipo o numero di file.",
    "hubspot-missing-scopes": "Il token HubSpot non ha i permessi necessari. Aggiungi lo scope \"crm.objects.owners.read\".",
    "input-validation": "Validazione input fallita. Verifica il formato dei dati.",
    "internal-server-error": "Si è verificato un errore imprevisto. Riprova più tardi.",
    "mcp-endpoint-invalid": "Questo URL non punta a un endpoint MCP. Controlla il percorso, di solito i server MCP lo espongono sotto /mcp.",
    "method-not-allowed": "Metodo HTTP non consentito per questo endpoint.",
    "not-found": "Pagina non trovata.",
    "oauth-authorization-required": "Autorizzazione OAuth richiesta. Completa il flusso di autorizzazione per questo server MCP.",
    "oauth-config-incomplete": "Configurazione OAuth incompleta. Imposta il Client ID per abilitare OAuth.",
    "origin-not-allowed": "L'origine della richiesta non è consentita.",
    "rate-limit-exceeded": "Troppe richieste. Riprova più tardi.",
    "unauthorized": "Autenticazione richiesta. Effettua l'accesso.",
    "validation-error": "Errore di validazione. Verifica i dati inviati."
  },
  "releaseNotes": {
    "heading": "Novità",
    "installed": "Stai usando la",
    "lead": "Ultime funzionalità, miglioramenti e correzioni."
  },
  "role": {
    "admin": "Amministratore",
    "member": "Membro",
    "owner": "Proprietario",
    "user": "Utente"
  },
  "route": {
    "agentEndpoints": "API Endpoints",
    "agents": "Agenti",
    "apiTools": "API Tools",
    "backoffice": "Backoffice",
    "catalog": "Catalogo",
    "channels": "Canali",
    "chatLogs": "Chat",
    "copatForYou": "Eight Wave for-U",
    "dashboard": "Dashboard",
    "documents": "Documenti",
    "endpointLogs": "Log endpoint",
    "feedbacks": "Feedback",
    "folders": "Cartelle",
    "frontoffice": "Frontoffice",
    "home": "Home",
    "integrations": "Integrazioni",
    "invitations": "Inviti",
    "leads": "Contatti",
    "mcpServer": "Server MCP",
    "members": "Membri",
    "notFound": "Pagina non trovata",
    "notifications": "Notifiche",
    "organizations": "Organizzazioni",
    "playground": "Playground",
    "profile": "Profilo",
    "reasoningLogs": "Ragionamento",
    "releaseNotes": "Note di rilascio",
    "requestPasswordReset": "Password dimenticata",
    "resetPassword": "Reimposta password",
    "revisedAnswers": "Correzioni",
    "signIn": "Accedi",
    "signUp": "Registrati",
    "subAgents": "Sotto-agenti",
    "system": "Sistema",
    "timingDebug": "Debug Performance",
    "users": "Utenti",
    "video": "Video",
    "virtualAssistant": "Assistente virtuale"
  },
  "showForm": {
    "completed": "Completato",
    "otherPlaceholder": "Altro...",
    "step": "Domanda {current} di {total}"
  },
  "subAgentStatus": {
    "active": "Attivo",
    "inactive": "Inattivo"
  },
  "time": {
    "future": "tra",
    "past": "fa",
    "unit": {
      "day": "giorno | giorni",
      "hour": "ora | ore",
      "minute": "minuto | minuti",
      "second": "secondo | secondi"
    }
  },
  "toolApproval": {
    "approved": "Approvato: l'azione è stata eseguita.",
    "cancelled": "Annullato: l'azione non è stata eseguita.",
    "confirmed": "Confermato: l'agente ha proseguito con l'azione.",
    "denied": "Rifiutato: l'azione non è stata eseguita.",
    "expired": "Questa richiesta non è più confermabile: l'azione non è stata eseguita.",
    "prompt": "Per continuare serve la tua conferma:"
  },
  "toolGroup": {
    "channels": "Canali di messaggistica",
    "communication": "Comunicazione",
    "delegation": "Delega e automazione",
    "knowledgeSearch": "Knowledge base e ricerca",
    "locationWeather": "Localizzazione e meteo",
    "personalization": "Personalizzazione",
    "richContent": "Contenuti interattivi"
  },
  "toolGroupInfo": {
    "channels": "Capacità aggiuntive sulle piattaforme di messaggistica come Microsoft Teams.",
    "communication": "Email, messaggi, moduli di contatto ed eventi calendario.",
    "delegation": "Worker generici che l'agente può eseguire in parallelo per gestire sotto-attività indipendenti.",
    "knowledgeSearch": "Ricerca nella knowledge base, fonti documentali e suggerimenti di pagine web.",
    "locationWeather": "Geolocalizzazione, geocodifica, mappe interattive e previsioni meteo.",
    "personalization": "Memoria per-utente e file caricati dall'utente stesso.",
    "richContent": "Contenuti strutturati: artefatti, confronti, gallerie di immagini, codici QR e risposte guidate."
  },
  "tooltip": {
    "agentsUsedInfo": "Numero di agenti utilizzati rispetto al massimo disponibile.",
    "requestsUsedInfo": "Numero di richieste utilizzate rispetto al massimo consentito."
  },
  "userFiles": {
    "allAgents": "Tutti gli agenti",
    "chatFilesEmpty": "Nessun file caricato in questa chat.",
    "chatFilesTitle": "File in questa chat",
    "emptyHint": "I file che carichi in chat vengono aggiunti qui automaticamente e diventano ricercabili dall'assistente.",
    "emptyTitle": "Nessun file",
    "exclude": "Rimuovi file",
    "excludeConfirm": "Rimuovere questo file dai tuoi file? L'assistente non potrà più cercarlo. Resta disponibile nella chat in cui l'hai caricato.",
    "excludeTitle": "Rimuovi file",
    "loading": "Caricamento…",
    "open": "Apri file",
    "openInChat": "Apri nella chat",
    "subtitle": "I file che hai caricato in chat, disponibili all'assistente.",
    "title": "I miei file",
    "untitled": "File senza nome",
    "uploadedAt": "Caricato"
  },
  "validation": {
    "invalidPhoneNumber": "Il numero inserito non è corretto",
    "invalidToolName": "Il nome deve essere in snake_case o kebab-case (lettere minuscole, numeri, underscore e trattini)",
    "passwordMismatch": "Le password non coincidono"
  },
  "voiceEagerness": {
    "eager": "Pronto",
    "normal": "Normale",
    "patient": "Paziente"
  },
  "weather": {
    "airQuality": "Qualità dell'aria",
    "aqiFair": "Discreta",
    "aqiGood": "Buona",
    "aqiHazardous": "Pessima",
    "aqiModerate": "Moderata",
    "aqiPoor": "Scarsa",
    "aqiVeryPoor": "Molto scarsa",
    "dailyForecast": "Previsioni giornaliere",
    "feelsLike": "Percepita",
    "today": "Oggi"
  }
}
